define('viewmodels/survey/SurveyTracking',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, app, appsecurity, navigation, system, logger, utils, ObjGeneralSettings) {
        var SurveyTrackingVM = {
            attached: attached,
            activate: activate,
            logger: logger,
            utils: utils,
            appsecurity: appsecurity,
            ObjGeneralSettings: ObjGeneralSettings,
            BUTitle: ko.observable('Business Unit'),
            RGName: ko.observable('Responsibility Group'),
            LocaleCheckFlag: ko.observable(false),
            SurveyProcessPointsList: ko.observableArray(),
            SortArray: ko.observableArray([]),
            BusinessDerivedList: ko.observable(),
            ClickedSurveyPoints: ko.observableArray([]),
            BUTypeDrpDwnList: ko.observableArray(),
            SelectedDrpDwnValueBU: ko.observable("ALL"),
            SelectedBUName: ko.observable(),
            PushbackTheSurveyAjax: PushbackTheSurveyAjax,
            btnCloseActionPopup: btnCloseActionPopup,
            ProcessPointsList: ko.observableArray([]),
            PossiblePushbackList: ko.observableArray([]),
            OrgLvlDrpDwnList: ko.observableArray(),
            ApplyFiltersclickedcount: ko.observable(),
            OrgLvlValueList: ko.observableArray(),
            SelectedOrgDrpDwnValue: ko.observable("ALL"),
            SelectedCountry: ko.observable("ALL"),
            OrgEntityList: ko.observableArray(),
            OrgInprogressList: ko.observableArray(),
            OrgCompletedList: ko.observableArray(),
            OrgNotStartedList: ko.observableArray(),
            OrgL2InprogressList: ko.observableArray(),
            OrgL1InprogressList: ko.observableArray(),
            OrgTotalList: ko.observableArray(),
            SurveyTrackingList: ko.observableArray(),
            ViewChart: ko.observable(),
            finalizeSurvey: finalizeSurvey,
            ApplyFilters: ApplyFilters,
            OverallMetrics: ko.observableArray(),
            CollapseCheckbox: CollapseCheckbox,
            CheckboxSelected: CheckboxSelected,
            ViewStatus: ViewStatus,
            ExportSurveyToExcel: ExportSurveyToExcel,
            CheckBoxCount: ko.observable(),
            DownloadSurveyResponsderReviewerReport: DownloadSurveyResponsderReviewerReport,
            RouteToResponseScreen: RouteToResponseScreen,
            SurveyGenerationStatus: ko.observable(1),
            DownloadSurveyDocuments: DownloadSurveyDocuments,
            BuId: ko.observable(),
            SurveyProfileId: ko.observable(),
            SurveyName: ko.observable(),
            PushbackPopUpClick: PushbackPopUpClick,
            PushbackEventId: ko.observable(),
            PushbackEventName: ko.observable(),
            SurveyUIDPushback: ko.observable(),
            // Filter Functionality
            openSideNav: openSideNav,
            closeSideNav: closeSideNav,
            IsSideNavOpen: ko.observable(0),
            BindHTMLFilters: BindHTMLFilters,
            SubCheckboxSelected: SubCheckboxSelected,
            FiltersListFlag: ko.observable(false),
            SelectedCheckedList: ko.observableArray([]),
            SelectedCheckedBUList: ko.observableArray([]),
            SelectedCheckedStatusList: ko.observableArray([]),
            SelectedCheckedBUFiltersList: ko.observableArray([]),
            BusinessUnitList: ko.observableArray([]),
            BusinessUnitListForFilters: ko.observableArray([]),
            BusinessUnitListForFiltersDUP: ko.observableArray([]),
            FinalOrgFilterList: ko.observableArray([]),
            DistinctFileredBUs: ko.observableArray([]),
            DistinctFileredStatus: ko.observableArray([]),
            DistinctFileredSurveyType: ko.observableArray([]),
            NumberOfBUsSelected: ko.observable(0),
            SetFilterSelection: SetFilterSelection,
            SetBUFilterSelection: SetBUFilterSelection,
            BUFiltersApplied: ko.observable(false),
            BusinessUnitListDUP: ko.observableArray([]),
            GetAllBusinessUnitsForFilters: GetAllBusinessUnitsForFilters,
            SelectedBUs: ko.observable(),
            SelectedFilters: ko.observable(),
            ClearAllBuFilters: ClearAllBuFilters,
            StatusFilter: ko.observable('Status'),
            SurveyTypeFilterName: ko.observable('Survey Type'),
            StatusFilterValues: ko.observableArray([]),
            SetStatusFilterSelection: SetStatusFilterSelection,
            SetSurveyTypeFilterSelection: SetSurveyTypeFilterSelection,
            SurveyTypeFilter: ko.observable([]),
            SelectedCheckedSurveyTypeList: ko.observableArray([]),
            SelectedSurveyTypeFilters: ko.observable(''),
            GetAllSurveyProfileTypes: GetAllSurveyProfileTypes,
            viewSurveyTimeline: viewSurveyTimeline,
            SurveyTimelineComments: ko.observableArray([]),
            CurrentProfileOfAssessmentId: ko.observable(),
            workflowModelList: ko.observableArray([]),
            ClearOrgFilterSelection: ClearOrgFilterSelection,
            ClearBUFilterSelection: ClearBUFilterSelection,
            ClearStatusFilterSelection: ClearStatusFilterSelection,
            ClearSurveyTypeFilterSelection: ClearSurveyTypeFilterSelection,
            SendSurveyReminderNotification: SendSurveyReminderNotification,
            SendEmailtoValidRecepients: SendEmailtoValidRecepients,
            EmailTemplate: ko.observable(),
            showSurveyInfoClick: showSurveyInfoClick,
            AreFiltersApplied: ko.observable(0),
            NavPillId: ko.observable(''), // Survey as default Nav Pill
            NavTabClick: NavTabClick,
            applySrollableComponent: applySrollableComponent,
            //Navigate to Survey Response Page Methods
            RoleValue: ko.observable(),
            ResponseMoveArray: ko.observableArray([]),
            SurveyClick: SurveyClick,
            NavigateSurveyResponse: NavigateSurveyResponse,
            ResponseMoveModel: ResponseMoveModel,
            SurveyType: ko.observable(),
            RoutedFrom: ko.observable(''),
            SurveyTypeDisplayName: ko.observable(''),
            RoleId: ko.observable(),
            BusinessUnitFilters: ko.observableArray([]),
            RecheckSelectBoxOnReload: RecheckSelectBoxOnReload,
            RecheckSelectBoxOnClear: RecheckSelectBoxOnClear,
            SelectedSurveyName: ko.observable(),
            FiltersForGraphs: FiltersForGraphs,
            TimelineCommentsFlag: ko.observable(false),
            showTimelineComments: showTimelineComments,
            showWFDescription: showWFDescription,
            SelectedSurveyId: ko.observable(),
            CommentText: ko.observable(),
            SurveyStates: ko.observableArray([])
        };
        var RaTableObj;
        return SurveyTrackingVM;

        //#region Page-Load Methods 

        function activate() {
            try {
                SurveyTrackingVM.appsecurity.GetCurrentProfileOfAssessment().then(function () {
                    SurveyTrackingVM.CurrentProfileOfAssessmentId(SurveyTrackingVM.appsecurity.CurrentProfileOfAssessmentId());
                });

                SurveyTrackingVM.appsecurity.GetCurrentLocaleOfUser().then(function () {
                    if (SurveyTrackingVM.ObjGeneralSettings === undefined || SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList() === undefined || ((SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList() !== undefined || SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList() !== null) && SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                        SurveyTrackingVM.ObjGeneralSettings.GetLocalizedData(SurveyTrackingVM.appsecurity.CurrentLocaletextOfUser()).then(function () {
                            SurveyTrackingVM.BUTitle((SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList() == undefined || SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList() == null || SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList() == undefined || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList() == null || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());
                            SurveyTrackingVM.RGName((SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList() == undefined || SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList() == null || SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList() == undefined || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList() == null || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponsibilityGroup') == -1) ? 'Responsibility Group' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponsibilityGroup')].Name());
                            SurveyTrackingVM.LocaleCheckFlag(true);
                        });
                    }
                    else {
                        SurveyTrackingVM.BUTitle((SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList() == undefined || SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList() == null || SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList() == undefined || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList() == null || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());
                        SurveyTrackingVM.RGName((SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList() == undefined || SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList() == null || SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList() == undefined || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList() == null || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponsibilityGroup') == -1) ? 'Responsibility Group' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponsibilityGroup')].Name());
                        SurveyTrackingVM.LocaleCheckFlag(true);

                    }
                });

                if (SurveyTrackingVM.appsecurity != undefined && SurveyTrackingVM.appsecurity.userInfo() !== undefined && SurveyTrackingVM.appsecurity.userInfo().PrimaryRoleId() !== undefined) {
                    SurveyTrackingVM.RoleValue(SurveyTrackingVM.appsecurity.userInfo().PrimaryRoleId());
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source activate() in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                $('#error').hide();
                if (SurveyTrackingVM.ObjGeneralSettings.isNavigatedBackFromSurveyResponsePage() == false) {
                    SurveyTrackingVM.NavPillId("SUR");
                    SurveyTrackingVM.ApplyFiltersclickedcount(0);
                    SurveyTrackingVM.ViewChart(0);
                    SurveyTrackingVM.FiltersListFlag(false);
                    SurveyTrackingVM.BUFiltersApplied(false);
                    SurveyTrackingVM.NumberOfBUsSelected(0);
                }

                else if (SurveyTrackingVM.ObjGeneralSettings.isNavigatedBackFromSurveyResponsePage() == true) {
                    // This Block will be fucntional when a user is Re-navigating from response page

                    SurveyTrackingVM.NavPillId(SurveyTrackingVM.ObjGeneralSettings.NavPillIdSurveyTracking());
                    $('.nav-pills a').removeClass("active");
                    document.getElementById(SurveyTrackingVM.NavPillId()).classList.add("active");

                    BindHTMLFilters();
                    SetStatusFilterSelection();
                    SetSurveyTypeFilterSelection();
                    if (SurveyTrackingVM.SelectedCheckedList().length > 0) {
                        SetFilterSelection();
                    }
                    else {
                        SetBUFilterSelection();
                    }
                    RecheckSelectBoxOnReload();
                }
                ApplyFilters();
                RaTableObj = $('#tblSurveyTracking').DataTable(
                    {
                        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                        "pageLength": 10,
                        "stateSave": true
                    }
                );
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source attached() in SurveyTracking.js';
                logger.logMessage(msg);
            }
        };

        //#endregion

        //#region Get Methods

        function viewSurveyTimeline(data) {
            try {
                var commentType = 'PBC';
                SurveyTrackingVM.TimelineCommentsFlag(false);

                SurveyTrackingVM.SelectedSurveyName(data.SurveyName());
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/GetSurveyLevelComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: data.SurveyNumber(), SurveyType: data.PPDISPNAME(), CommentType: commentType, AssessmentProfileId: parseInt(SurveyTrackingVM.CurrentProfileOfAssessmentId()) })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: viewSurveyTimeline() method in SurveyTracking.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.substring(0, 3) == "INC") {
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                            ? jsonResult + " - An error occurred. Please contact your Application Administrator."
                            : jsonResult + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                            [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                    else if (jsonResult !== "") {
                        $('#noTimelineComments').hide();
                        $('#commentsTimeline').show();
                        SurveyTrackingVM.SurveyTimelineComments([]);
                        var convertedObj = JSON.parse(jsonResult);
                        var mappedList = ko.mapping.fromJS(convertedObj.Comments)();
                        SurveyTrackingVM.SurveyTimelineComments(mappedList);
                        $('#showCmpltTimelineBtn').show();
                        $('#showLessTimelineBtn').hide();
                    }
                    else {
                        $('#noTimelineComments').show();
                        $('#commentsTimeline').hide();
                        $('#showCmpltTimelineBtn').hide();
                        $('#showLessTimelineBtn').show();
                    }
                    GetUsersRoleWFDetails(data.SurveyNumber(), data.PPDISPNAME());
                    $('#SurveyTimelinePopUp').modal('show');
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in viewSurveyTimeline() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in viewSurveyTimeline() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in viewSurveyTimeline() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetUsersRoleWFDetails(surveyId, surveyType) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    url: "/api/Configuration/GetRoleUserDetailsForBUSocializationWorkFLow",
                    data: ko.toJSON({
                        "SurveyId": surveyId,
                        "Survey_type": surveyType
                    }),
                    type: "POST",
                    headers: headers
                })
                    .success(function (jsonResult, success) {
                        SurveyTrackingVM.workflowModelList([]);
                        if (jsonResult == null) {
                            $('#UsersRoleWFChevrons').hide();
                        }
                        else {
                            if (jsonResult.length > 0 && jsonResult[0].RoleID == -99) {
                                $('#UsersRoleWFChevrons').hide();
                                logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                                    ? jsonResult[0].RoleName + " - An error occurred. Please contact your Application Administrator."
                                    : jsonResult[0].RoleName + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                                    [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                            }
                            else if (jsonResult.length > 0) {
                                $('#UsersRoleWFChevrons').show();
                                SurveyTrackingVM.workflowModelList(jsonResult);
                            }
                        }
                    })
                    .fail(function (error, fail) { });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in GetUsersRoleWFDetails() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        //#region Filter related Get Methods 

        // to fetch all Org Level details - Used in filters
        function GetAllOrganizationalLevels() {
            try {
                return $.ajax({
                    url: "/api/Configuration/getDistinctBusinessLevelsAll",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllOrganizationalLevels() in SurveyTracking.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult[0].IsCompletedFlag == -1) {
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                            ? jsonResult[0].SurveyStatus + " - An error occurred. Please contact your Application Administrator."
                            : jsonResult[0].SurveyStatus + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                            [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                    else if (jsonResult != undefined && jsonResult.length > 0 && jsonResult[0].IsCompletedFlag != -1) {
                        if (jsonResult != null) {
                            var OrganizationalLevels = $.map(jsonResult, function (result) {
                                return new BusinessLevelsModel(result);
                            });

                            if (OrganizationalLevels.length > 0) {
                                SurveyTrackingVM.OrgLvlDrpDwnList(OrganizationalLevels);
                                BindHTMLFilters();
                                SurveyTrackingVM.OrgLvlValueList(SurveyTrackingVM.OrgLvlDrpDwnList()[0].BusinessLevelValueList());
                            }
                            else {
                                BindHTMLFilters();
                            }
                        }
                    }
                    else {
                        var msg = (!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logError(msg, 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllOrganizationalLevels() in SurveyTracking.js';
                    logger.logMessage(msg);

                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }
        }

        // to fetch all SP Names and 'Socialization Surveys' - Used in filters
        function GetAllSurveyProfileTypes() {
            try {
                return $.ajax({
                    url: "/api/Survey/GetSurveyProfileTypes",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' || Source: ajax call in GetAllSurveyProfileTypes() in SurveyTracking.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult[0].SurveyProfileId == -1) {
                        $('#MainPage_Div').hide();
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                            ? jsonResult[0].SurveyProfileName + " - An error occurred. Please contact your Application Administrator."
                            : jsonResult[0].SurveyProfileName + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                            [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                    else if (jsonResult != undefined && jsonResult.length > 0 && jsonResult[0].SurveyProfileId != -1) {

                        if (jsonResult != null) {
                            var mappedSurvey = $.map(jsonResult, function (result) {
                                return new SurveyProfileModel(result);
                            });
                            SurveyTrackingVM.SurveyTypeFilter(mappedSurvey);
                        }
                    }
                    else {
                        $('#MainPage_Div').hide();
                        var msg = (!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logError(msg, 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                }

                catch (e) {
                    $('#MainPage_Div').hide();
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllSurveyProfileTypes() in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    $('#MainPage_Div').hide();
                    if (error.status == 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllSurveyProfileTypes() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllSurveyProfileTypes() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }
        }

        // to fetch all Business Unit details - Used in filters
        function GetAllBusinessUnitsForFilters() {
            try {
                return $.ajax({
                    url: "/api/Survey/getAllBusinessUnitsFilters",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllBusinessUnitsForFilters() in SurveyTracking.js';
                logger.logMessage(msg);

            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult != undefined && jsonResult.length > 0) {
                        if (jsonResult[0].IsCompletedFlag == -1) {
                            logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                                ? jsonResult[0].SurveyStatus + " - An error occurred. Please contact your Application Administrator."
                                : jsonResult[0].SurveyStatus + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                                [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                        }
                        else {
                            var mappedBuList = $.map(jsonResult, function (result) {
                                return new BusinessUnitModel(result);
                            });
                            SurveyTrackingVM.BusinessUnitListForFiltersDUP(mappedBuList);
                            SurveyTrackingVM.BusinessUnitFilters(mappedBuList);

                            SurveyTrackingVM.BusinessUnitListDUP = ko.dependentObservable(function () {
                                var seen = [];
                                return mappedBuList.filter(function (n) {
                                    return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                                });
                            });
                            BindHTMLFilters();
                            $('#OrgFilterError').hide();
                            $('#BUFilterError').hide();
                            document.getElementById("sideNav").style.top = "unset";
                            document.getElementById("sideNav").style.height = "auto";
                            SurveyTrackingVM.FiltersListFlag(true);
                        }
                    }
                    else {
                        var msg = (!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logError(jsonResult[0].SurveyStatus + " - " + msg, 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllBusinessUnitsForFilters() in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }
        }

        //navtabclick also uses this to fetch the actual data
        function ApplyFilters() {
            try {
                $('#SurDetailTabDiv').hide();
                $('#loadingImgSurveyTracking').show();

                SurveyTrackingVM.SelectedBUs('');
                var SelectedBUsString = "";

                if (SurveyTrackingVM.SelectedCheckedList().length > 0 || SurveyTrackingVM.SelectedCheckedBUList().length > 0) {
                    for (var i = 0; i < SurveyTrackingVM.BusinessUnitListForFilters().length; i++) {
                        if (SelectedBUsString === "")
                            SelectedBUsString = SurveyTrackingVM.BusinessUnitListForFilters()[i].BusinessUnitId().toString();
                        else
                            SelectedBUsString += "," + SurveyTrackingVM.BusinessUnitListForFilters()[i].BusinessUnitId().toString();
                    }
                }

                var SelectedFilterString = "";
                for (var i = 0; i < SurveyTrackingVM.SelectedCheckedStatusList().length; i++) {
                    if (SelectedFilterString === "")
                        SelectedFilterString = SurveyTrackingVM.SelectedCheckedStatusList()[i].Process_Id.toString();
                    else
                        SelectedFilterString += "," + SurveyTrackingVM.SelectedCheckedStatusList()[i].Process_Id.toString();
                }

                var SelectedSurveyTypeFilterString = "";
                for (var i = 0; i < SurveyTrackingVM.SelectedCheckedSurveyTypeList().length; i++) {
                    if (SelectedSurveyTypeFilterString === "")
                        SelectedSurveyTypeFilterString = SurveyTrackingVM.SelectedCheckedSurveyTypeList()[i].SurveyType_Id.toString();
                    else
                        SelectedSurveyTypeFilterString += "," + SurveyTrackingVM.SelectedCheckedSurveyTypeList()[i].SurveyType_Id.toString();
                }

                SurveyTrackingVM.SelectedBUs(SelectedBUsString);

                if (SurveyTrackingVM.SelectedBUs() === undefined)
                    SurveyTrackingVM.SelectedBUs("");

                SurveyTrackingVM.SelectedFilters(SelectedFilterString);

                if (SurveyTrackingVM.SelectedFilters() === undefined)
                    SurveyTrackingVM.SelectedFilters("");

                SurveyTrackingVM.SelectedSurveyTypeFilters(SelectedSurveyTypeFilterString);

                if (SurveyTrackingVM.SelectedSurveyTypeFilters() === undefined)
                    SurveyTrackingVM.SelectedSurveyTypeFilters("");

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/PostSurveyTrackingDetailstable",
                    headers: headers,
                    type: "POST",
                    applicationType: 'application/json',
                    dataType: 'json',
                    data: { SelectedBUs: SurveyTrackingVM.SelectedBUs(), SelectedFilters: SurveyTrackingVM.SelectedFilters(), SelectedSurveyProfiles: SurveyTrackingVM.SelectedSurveyTypeFilters(), GetDataType: SurveyTrackingVM.NavPillId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

            }
            catch (e) {
                var msg = 'Exception' + e + ' || source: ajax call in ApplyFilters() in SurveyTracking.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    $('#loadingImgSurveyTracking').hide();
                    $('#SurDetailTabDiv').show();

                    if (jsonResult.ErrorID == -1) {
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                            ? jsonResult.ErrorName + " - An error occurred. Please contact your Application Administrator."
                            : jsonResult.ErrorName + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                            [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                    var SurveyLegendsData = $.map(jsonResult.SurveyTrackingLegend, function (result) {
                        return new SurveyLegendModel(result);
                    });

                    SurveyTrackingVM.SurveyStates(SurveyLegendsData);

                    var SurveyTrackingData = $.map(jsonResult.SurveyTrackingData, function (result) {
                        return new SurveytrackingModel(result);
                    });

                    var p = $('#tblSurveyTracking').DataTable().page.info().page
                    RaTableObj.destroy();
                    $('#tblSurveyTracking tbody tr').remove();
                    SurveyTrackingVM.SurveyTrackingList([]);
                    SurveyTrackingVM.SurveyTrackingList(SurveyTrackingData);

                    RaTableObj = $('#tblSurveyTracking').DataTable({
                        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                        "pageLength": 10,
                        "language": {
                            searchPlaceholder: "Search"
                        },
                        "searchDelay": 350,
                        "stateSave": true,
                        "initComplete": function () {
                            this.api().columns().every(function () {
                                var column = this;
                                if (column[0][0] != '0' && column[0][0] != '5' && column[0][0] != '6') {
                                    var select = $('<select style=" width:100%; overflow: hidden;"> <option value="">All</option></select>')
                                        .appendTo($(column.footer()).empty())
                                        .on('change', function () {
                                            var val = $.fn.dataTable.util.escapeRegex(
                                                $(this).val()
                                            );

                                            column
                                                .search(val ? '^' + val + '$' : '', true, false)
                                                .draw();
                                        });

                                    column.data().unique().sort().each(function (d, j) {
                                        select.append('<option value="' + d + '">' + d + '</option>')
                                    });
                                }
                            });
                        }
                    });

                    closeSideNav();

                    if (SurveyTrackingVM.SelectedSurveyTypeFilters() == "" && SurveyTrackingVM.SelectedFilters() == "" && SurveyTrackingVM.SelectedBUs() == "") {
                        SurveyTrackingVM.AreFiltersApplied(0);
                    }
                    else {
                        SurveyTrackingVM.AreFiltersApplied(1);
                    }

                    RaTableObj.page(p).draw(false);
                    SurveyTrackingVM.ApplyFiltersclickedcount(SurveyTrackingData.length);

                    var ProcessPointsLevels = $.map(jsonResult.ProcessPointsData, function (result) {
                        if (result.PROCESS_ID != 0)
                            return new ProcessPointsModel(result);
                    });
                    SurveyTrackingVM.StatusFilterValues(ProcessPointsLevels);

                    var mappedSurveyProcessList = $.map(jsonResult.ProcessPointsData, function (result) {
                        return new SurveyProcessModel(result);
                    });
                    SurveyTrackingVM.SurveyProcessPointsList(mappedSurveyProcessList);
                    TotalMetrics = [];
                    for (var i = 0; i < SurveyTrackingVM.SurveyProcessPointsList().length; i++) {
                        TotalMetrics.push(parseInt(SurveyTrackingVM.SurveyProcessPointsList()[i].COUNT()));
                    }
                    SurveyTrackingVM.OverallMetrics(TotalMetrics);
                    BindPieChartForProcessPoints();
                    DrawPieChartForProcessPoints();
                }
                catch (e) {
                    var msg = 'Exception' + e + ' || source: ajaxSuccess in ApplyFilters() in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' || Source: ajaxFail in ApplyFilters() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' || Source: ajaxFail in ApplyFilters() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion

        //#endregion

        //#region Filter

        function BindHTMLFilters() {
            try {
                //Org Level Filter Fossil style
                var OrgList = "";
                OrgList += '<div class="filter-nav1">' +
                    '<ul class="nav nav-tabs"><li class="fl-lbl"><span data-bind="html: (!SurveyTrackingVM.LocaleCheckFlag() ||  SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf("AddFilters") == -1 )?"Add Filters": $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf("AddFilters")].Name"></span></li>';

                for (var i = 0; i < SurveyTrackingVM.OrgLvlDrpDwnList().length; i++) {
                    if (i == 0) {
                        OrgList += '<li class=""><a href="#tab_' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BlName() + '<i class="fa fa-chevron-down ml-1" aria-hidden="true"></i> </a></li>'
                    } else {
                        OrgList += '<li class=""><a href="#tab_' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BlName() + '<i class="fa fa-chevron-down ml-1" aria-hidden="true"></i> </a></li>'
                    }
                }
                OrgList += '<li class=""><a href="#tab_BU" data-toggle="tab">' + SurveyTrackingVM.BUTitle() + '<i class="fa fa-chevron-down ml-1" aria-hidden="true"></i> </a></li>'

                OrgList += '<li class=""><a href="#tab_Status" data-toggle="tab">' + SurveyTrackingVM.StatusFilter() + '<i class="fa fa-chevron-down ml-1" aria-hidden="true"></i> </a></li>'

                OrgList += '<li class=""><a href="#tab_SurveyType" data-toggle="tab">' + SurveyTrackingVM.SurveyTypeFilterName() + '<i class="fa fa-chevron-down ml-1" aria-hidden="true"></i> </a></li>'

                OrgList += '</ul>' +
                    '<div class="tab-content filter-content">';

                for (var i = 0; i < SurveyTrackingVM.OrgLvlDrpDwnList().length; i++) {
                    if (i == 0) {
                        OrgList += '<div class="tab-pane active" id="tab_' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BlId() + '">'
                    } else {
                        OrgList += '<div class="tab-pane" id="tab_' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BlId() + '">'
                    }

                    if (SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length > 0) {

                        for (var j = 0; j < SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                            OrgList += '<label class="ft-selection">' +
                                '<input id=sublevel' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;">' +
                                '<i class="fa fa-check ' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + '" aria-hidden="true" style="display:none"></i>' +
                                '<span class="cc-facet-result-text tag-text">' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueName() + '</span>' +
                                '</label>';
                        }

                    }

                    OrgList += '</div>';
                }
                OrgList += '<div class="tab-pane" id="tab_BU">';

                SurveyTrackingVM.DistinctFileredBUs = ko.dependentObservable(function () {
                    var seen = [];
                    return SurveyTrackingVM.BusinessUnitListForFiltersDUP().filter(function (n) {
                        return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                    });
                });

                SurveyTrackingVM.BusinessUnitFilters(SurveyTrackingVM.DistinctFileredBUs());

                for (var w = 0; w < SurveyTrackingVM.BusinessUnitFilters().length; w++) {
                    OrgList += '<label class="ft-selection">' +
                        '<input id=sublevelBU' + SurveyTrackingVM.BusinessUnitFilters()[w].BusinessUnitId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" class="heatmap-sublevel">' +
                        '<i class="fa fa-check ' + SurveyTrackingVM.BusinessUnitFilters()[w].BusinessUnitId() + '" aria-hidden="true" style="display:none"></i>' +
                        '<span class="cc-facet-result-text tag-text">' + SurveyTrackingVM.BusinessUnitFilters()[w].BusinessUnitName() + '</span>' +
                        '</label>';
                }
                OrgList += '</div>';

                OrgList += '<div class="tab-pane" id="tab_Status">';

                for (var n = 0; n < SurveyTrackingVM.StatusFilterValues().length; n++) {
                    OrgList += '<label class="ft-selection">' +
                        '<input id=sublevelStatus' + SurveyTrackingVM.StatusFilterValues()[n].PROCESS_ID() + ' type="checkbox" class="heatmap-sublevel">' +
                        '<i class="fa fa-check ' + SurveyTrackingVM.StatusFilterValues()[n].PROCESS_ID() + '" aria-hidden="true" style="display:none"></i>' +
                        '<span class="cc-facet-result-text tag-text">' + SurveyTrackingVM.StatusFilterValues()[n].PROCESS_POINT_NAME() + '</span>' +
                        '</label>';
                }

                SurveyTrackingVM.DistinctFileredStatus = ko.dependentObservable(function () {
                    var seen = [];
                    return SurveyTrackingVM.StatusFilterValues().filter(function (n) {
                        return seen.indexOf(n) == -1 && seen.push(n);
                    });
                });

                SurveyTrackingVM.StatusFilterValues(SurveyTrackingVM.DistinctFileredStatus());


                OrgList += '</div>';

                OrgList += '<div class="tab-pane" id="tab_SurveyType">';

                for (var t = 0; t < SurveyTrackingVM.SurveyTypeFilter().length; t++) {
                    OrgList += '<label class="ft-selection">' +
                        '<input id=sublevelSurveyType' + SurveyTrackingVM.SurveyTypeFilter()[t].SurveyProfileId() + ' type="checkbox" class="heatmap-sublevel">' +
                        '<i class="fa fa-check ' + SurveyTrackingVM.SurveyTypeFilter()[t].SurveyProfileId() + '" aria-hidden="true" style="display:none"></i>' +
                        '<span class="cc-facet-result-text tag-text">' + SurveyTrackingVM.SurveyTypeFilter()[t].SurveyProfileName() + '</span>' +
                        '</label>';
                }

                SurveyTrackingVM.DistinctFileredSurveyType = ko.dependentObservable(function () {
                    var seen = [];
                    return SurveyTrackingVM.SurveyTypeFilter().filter(function (n) {
                        return seen.indexOf(n) == -1 && seen.push(n);
                    });
                });

                SurveyTrackingVM.SurveyTypeFilter(SurveyTrackingVM.DistinctFileredSurveyType());


                OrgList += '</div>';


                if (OrgList == "") {
                    OrgList = '<div id="NoorganizationalLevelerror" class="alert-warning"><label class="control-label"  data-bind="html: (!SurveyTrackingVM.LocaleCheckFlag() ||  SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf("OrgLevelsNotConfigured") == -1 )?"Organizational Levels are not configured for this Year of Assessment.": $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf("OrgLevelsNotConfigured")].Name"></label></div>';

                }
                document.getElementById('OrganizationalLevel').innerHTML = OrgList;
                var element = $('#tab_Status')[0];
                ko.cleanNode(element);
                ko.applyBindings(SurveyTrackingVM, document.getElementById('tab_Status'));


                for (var i = 0; i < SurveyTrackingVM.OrgLvlDrpDwnList().length; i++) {
                    for (var l = 0; l < SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; l++) {
                        ko.applyBindingsToNode($('#sublevel' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[l].BlvalueId()), { event: { change: SurveyTrackingVM.SubCheckboxSelected } }, SurveyTrackingVM);
                    }
                }

                for (var k = 0; k < SurveyTrackingVM.BusinessUnitFilters().length; k++) {
                    ko.applyBindingsToNode($('#sublevelBU' + SurveyTrackingVM.BusinessUnitFilters()[k].BusinessUnitId()), { event: { change: SurveyTrackingVM.SubCheckboxSelected } }, SurveyTrackingVM);
                }

                for (var l = 0; l < SurveyTrackingVM.StatusFilterValues().length; l++) {
                    ko.applyBindingsToNode($('#sublevelStatus' + SurveyTrackingVM.StatusFilterValues()[l].PROCESS_ID()), { event: { change: SurveyTrackingVM.SubCheckboxSelected } }, SurveyTrackingVM);
                }

                for (var q = 0; q < SurveyTrackingVM.SurveyTypeFilter().length; q++) {
                    ko.applyBindingsToNode($('#sublevelSurveyType' + SurveyTrackingVM.SurveyTypeFilter()[q].SurveyProfileId()), { event: { change: SurveyTrackingVM.SubCheckboxSelected } }, SurveyTrackingVM);
                }

                $('#loadingImgMainHm').modal('hide');

                if (SurveyTrackingVM.ObjGeneralSettings.isNavigatedBackFromSurveyResponsePage() == false) {
                    if (SurveyTrackingVM.SelectedCheckedList().length > 0 || SurveyTrackingVM.SelectedCheckedBUList().length > 0)
                        SurveyTrackingVM.NumberOfBUsSelected(SurveyTrackingVM.BusinessUnitFilters().length); // 30 initially
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source: BindHTMLFilters function in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function CollapseCheckbox(data, event) {
            try {
                if (event.currentTarget.className == "fa fa-plus-square-o") {
                    document.getElementById(event.currentTarget.id).removeClass("fa fa-plus-square-o");
                    document.getElementById(event.currentTarget.id).addClass("fa fa-minus-square-o");
                } else {
                    document.getElementById(event.currentTarget.id).removeClass("fa fa-minus-square-o");
                    document.getElementById(event.currentTarget.id).addClass("fa fa-plus-square-o");
                }
                $('#' + event.currentTarget.id + 'Child').toggle();
            }
            catch (e) {
                var msg = 'Exception' + e + ' || Source:  CollapseCheckbox function in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function CheckboxSelected(data, event) {
            try {
                for (var i = 0; i < SurveyTrackingVM.OrgLvlDrpDwnList().length; i++) {
                    if (SurveyTrackingVM.OrgLvlDrpDwnList()[i].BlId() == event.currentTarget.id) {
                        for (var j = 0; j < SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                            if (event.currentTarget.checked)
                                $("#sublevel" + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId()).prop("checked", true);
                            else
                                $("#sublevel" + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId()).prop("checked", false);
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source:  CheckboxSelected function in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function ClearAllBuFilters(data, event) {
            try {
                RecheckSelectBoxOnClear();
                SurveyTrackingVM.BusinessUnitList(SurveyTrackingVM.BusinessUnitListDUP());
                SurveyTrackingVM.SelectedCheckedBUList([]);
                SurveyTrackingVM.SelectedCheckedList([]);
                SurveyTrackingVM.BusinessUnitListForFilters([]);
                SurveyTrackingVM.SelectedBUs('');
                SurveyTrackingVM.NumberOfBUsSelected(0);
                closeSideNav();

                SurveyTrackingVM.BUFiltersApplied(false);
                SurveyTrackingVM.SelectedCheckedStatusList([]);
                SurveyTrackingVM.SelectedCheckedSurveyTypeList([]);

                SetStatusFilterSelection();
                SetFilterSelection();
                SetSurveyTypeFilterSelection();

                $('.badge').css({ 'display': 'none' });
                SurveyTrackingVM.AreFiltersApplied(0);
                $('#ParentDynamicOrgOptedFilters').innerHTML = '';
                ApplyFilters();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearAllBuFilters() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function openSideNav() {
            try {
                if (SurveyTrackingVM.IsSideNavOpen() == 1) {
                    $('#sideNav').fadeOut(200);
                    SurveyTrackingVM.IsSideNavOpen(0);
                }
                else {
                    $('#sideNav').fadeIn(200);
                    $('#OrgFilterError').hide();
                    $('#BUFilterError').hide();
                    document.getElementById("sideNav").style.top = "unset";
                    document.getElementById("sideNav").style.height = "auto";
                    SurveyTrackingVM.IsSideNavOpen(1);
                    if (SurveyTrackingVM.FiltersListFlag() == false) {
                        GetAllOrganizationalLevels();
                        GetAllSurveyProfileTypes();
                        GetAllBusinessUnitsForFilters();
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: openSideNav() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function closeSideNav() {
            try {
                $('#sideNav').fadeOut(200);
                $('#OrgFilterError').hide();
                $('#BUFilterError').hide();
                $('#loadingImgMain').modal('hide');
                SurveyTrackingVM.IsSideNavOpen(0);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: closeSideNav() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function RecheckSelectBoxOnClear() {
            try {
                if (SurveyTrackingVM.SelectedCheckedStatusList().length > 0) {
                    for (var g = 0; g < SurveyTrackingVM.SelectedCheckedStatusList().length; g++) {
                        $("#sublevelStatus" + SurveyTrackingVM.SelectedCheckedStatusList()[g].Process_Id).prop("checked", false);
                        $('.fa-check.' + SurveyTrackingVM.SelectedCheckedStatusList()[g].Process_Id).css({ 'display': 'none' });
                    }
                }

                if (SurveyTrackingVM.SelectedCheckedSurveyTypeList().length > 0) {
                    for (var g = 0; g < SurveyTrackingVM.SelectedCheckedSurveyTypeList().length; g++) {
                        $("#sublevelSurveyType" + SurveyTrackingVM.SelectedCheckedSurveyTypeList()[g].SurveyType_Id).prop("checked", false);
                        $('.fa-check.' + SurveyTrackingVM.SelectedCheckedSurveyTypeList()[g].SurveyType_Id).css({ 'display': 'none' });
                    }
                }

                if (SurveyTrackingVM.SelectedCheckedList().length > 0) {
                    for (var g = 0; g < SurveyTrackingVM.SelectedCheckedList().length; g++) {
                        $("#sublevel" + SurveyTrackingVM.SelectedCheckedList()[g].SubLevelId).prop("checked", false);
                        $('.fa-check.' + SurveyTrackingVM.SelectedCheckedList()[g].SubLevelId).css({ 'display': 'none' });
                    }
                }

                if (SurveyTrackingVM.SelectedCheckedBUList().length > 0) {
                    for (var g = 0; g < SurveyTrackingVM.SelectedCheckedBUList().length; g++) {
                        $("#sublevelBU" + SurveyTrackingVM.SelectedCheckedBUList()[g].SubLevelId).prop("checked", false);
                        $('.fa-check.' + SurveyTrackingVM.SelectedCheckedBUList()[g].SubLevelId).css({ 'display': 'none' });
                    }
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RecheckSelectBoxOnClear() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function RecheckSelectBoxOnReload() {
            try {
                if (SurveyTrackingVM.SelectedCheckedStatusList().length > 0) {
                    for (var g = 0; g < SurveyTrackingVM.SelectedCheckedStatusList().length; g++) {
                        $("#sublevelStatus" + SurveyTrackingVM.SelectedCheckedStatusList()[g].Process_Id).prop("checked", true);
                        $('.fa-check.' + SurveyTrackingVM.SelectedCheckedStatusList()[g].Process_Id).css({ 'display': 'inline-block' });
                    }
                }

                if (SurveyTrackingVM.SelectedCheckedSurveyTypeList().length > 0) {
                    for (var g = 0; g < SurveyTrackingVM.SelectedCheckedSurveyTypeList().length; g++) {
                        $("#sublevelSurveyType" + SurveyTrackingVM.SelectedCheckedSurveyTypeList()[g].SurveyType_Id).prop("checked", true);
                        $('.fa-check.' + SurveyTrackingVM.SelectedCheckedSurveyTypeList()[g].SurveyType_Id).css({ 'display': 'inline-block' });
                    }
                }

                if (SurveyTrackingVM.SelectedCheckedList().length > 0) {
                    for (var g = 0; g < SurveyTrackingVM.SelectedCheckedList().length; g++) {
                        $("#sublevel" + SurveyTrackingVM.SelectedCheckedList()[g].SubLevelId).prop("checked", true);
                        $('.fa-check.' + SurveyTrackingVM.SelectedCheckedList()[g].SubLevelId).css({ 'display': 'inline-block' });
                    }
                }

                if (SurveyTrackingVM.SelectedCheckedBUList().length > 0) {
                    for (var g = 0; g < SurveyTrackingVM.SelectedCheckedBUList().length; g++) {
                        $("#sublevelBU" + SurveyTrackingVM.SelectedCheckedBUList()[g].SubLevelId).prop("checked", true);
                        $('.fa-check.' + SurveyTrackingVM.SelectedCheckedBUList()[g].SubLevelId).css({ 'display': 'inline-block' });
                    }
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RecheckSelectBoxOnReload() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function SubCheckboxSelected(data, event) {
            try {
                $('#OrgFilterError').hide();
                $('#BUFilterError').hide();
                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("el") + 2);
                var BUselected = "";
                var StatusSelected = "";

                // CHECKS WHETHER SELECTED SUB CHECKBOX HAS STATUS OR NOT
                if (selectedSubOrgLevelID.includes("Status")) {
                    var counterCheck = 0;
                    for (var g = 0; g < SurveyTrackingVM.StatusFilterValues().length; g++) {
                        if (('Status' + SurveyTrackingVM.StatusFilterValues()[g].PROCESS_ID()) == selectedSubOrgLevelID) {
                            if (event.currentTarget.checked) {
                                $("#sublevelStatus" + SurveyTrackingVM.StatusFilterValues()[g].PROCESS_ID()).prop("checked", true);
                                $('.fa-check.' + SurveyTrackingVM.StatusFilterValues()[g].PROCESS_ID()).css({ 'display': 'inline-block' });

                                SurveyTrackingVM.SelectedCheckedStatusList.push({
                                    Process_Id: SurveyTrackingVM.StatusFilterValues()[g].PROCESS_ID(),
                                    Process_Name: SurveyTrackingVM.StatusFilterValues()[g].PROCESS_POINT_NAME(),
                                });
                            }
                            else {
                                $("#sublevelStatus" + SurveyTrackingVM.StatusFilterValues()[g].PROCESS_ID()).prop("checked", false);
                                $('.fa-check.' + SurveyTrackingVM.StatusFilterValues()[g].PROCESS_ID()).css({ 'display': 'none' });
                                if (SurveyTrackingVM.SelectedCheckedStatusList().length > 0) {
                                    SurveyTrackingVM.SelectedCheckedStatusList.remove(function (item) { return item.Process_Id == SurveyTrackingVM.StatusFilterValues()[g].PROCESS_ID() })
                                }

                            }
                            //Mark parent check box as checked if all sub levels are selected
                        }
                    }
                    SetStatusFilterSelection();
                }

                // CHECKS WHETHER SELECTED SUB CHECKBOX HAS SURVEY TYPE OR NOT
                else if (selectedSubOrgLevelID.includes("SurveyType")) {
                    var counterCheck = 0;
                    for (var g = 0; g < SurveyTrackingVM.SurveyTypeFilter().length; g++) {
                        if (('SurveyType' + SurveyTrackingVM.SurveyTypeFilter()[g].SurveyProfileId()) == selectedSubOrgLevelID) {
                            if (event.currentTarget.checked) {
                                $("#sublevelSurveyType" + SurveyTrackingVM.SurveyTypeFilter()[g].SurveyProfileId()).prop("checked", true);
                                $('.fa-check.' + SurveyTrackingVM.SurveyTypeFilter()[g].SurveyProfileId()).css({ 'display': 'inline-block' });

                                SurveyTrackingVM.SelectedCheckedSurveyTypeList.push({
                                    SurveyType_Id: SurveyTrackingVM.SurveyTypeFilter()[g].SurveyProfileId(),
                                    SurveyType_Name: SurveyTrackingVM.SurveyTypeFilter()[g].SurveyProfileName(),
                                });
                            }
                            else {
                                $("#sublevelSurveyType" + SurveyTrackingVM.SurveyTypeFilter()[g].SurveyProfileId()).prop("checked", false);
                                $('.fa-check.' + SurveyTrackingVM.SurveyTypeFilter()[g].SurveyProfileId()).css({ 'display': 'none' });
                                if (SurveyTrackingVM.SelectedCheckedSurveyTypeList().length > 0) {
                                    SurveyTrackingVM.SelectedCheckedSurveyTypeList.remove(function (item) { return item.SurveyType_Id == SurveyTrackingVM.SurveyTypeFilter()[g].SurveyProfileId() })
                                }

                            }
                            //Mark parent check box as checked if all sub levels are selected
                        }
                    }
                    SetSurveyTypeFilterSelection();
                }

                else if (isNaN(parseInt(selectedSubOrgLevelID)) && SurveyTrackingVM.SelectedCheckedList().length > 0) {
                    $('#BUFilterError').show();
                    return false;
                }
                else if (!isNaN(parseInt(selectedSubOrgLevelID)) && SurveyTrackingVM.SelectedCheckedBUList().length > 0) {
                    $('#OrgFilterError').show();
                    return false;
                }

                else if (!isNaN(parseInt(selectedSubOrgLevelID)) && SurveyTrackingVM.SelectedCheckedBUList().length == 0) {
                    for (var i = 0; i < SurveyTrackingVM.OrgLvlDrpDwnList().length; i++) {
                        var counterCheck = 0;
                        for (var g = 0; g < SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; g++) {
                            if (SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() == selectedSubOrgLevelID) {
                                if (event.currentTarget.checked) {
                                    $("#sublevel" + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", true);
                                    $('.fa-check.' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'inline-block' });

                                    SurveyTrackingVM.SelectedCheckedList.push({
                                        SubLevelId: SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId(),
                                        SubLevelName: SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueName(),
                                        OrgLevelName: SurveyTrackingVM.OrgLvlDrpDwnList()[i].BlName()
                                    });
                                }
                                else {
                                    $("#sublevel" + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", false);
                                    $('.fa-check.' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'none' });
                                    if (SurveyTrackingVM.SelectedCheckedList().length > 0) {
                                        SurveyTrackingVM.SelectedCheckedList.remove(function (item) { return item.SubLevelId == SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() })
                                    }
                                }
                            }

                            //Mark parent check box as checked if all sub levels are selected
                            if ($("#sublevel" + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop('checked')) {
                                counterCheck++;
                            }
                            if (counterCheck > 0 && counterCheck == SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                                $("#" + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BlId()).prop("checked", true);
                            }
                            else if (counterCheck > 0 && counterCheck == SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                                $("#" + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BlId()).prop("checked", false);
                            }
                        }
                    }
                    //Logic to re-set the BU list
                    SurveyTrackingVM.BusinessUnitListForFilters([]);
                    if (SurveyTrackingVM.SelectedCheckedList().length > 0) {
                        var mappedBuList = $.map(SurveyTrackingVM.BusinessUnitListForFiltersDUP(), function (result) {
                            for (var m = 0; m < SurveyTrackingVM.SelectedCheckedList().length; m++) {
                                if (result.SubLevelId() == SurveyTrackingVM.SelectedCheckedList()[m].SubLevelId)
                                    return new BusinessUnitModelDUP(result);
                            }
                        });
                        SurveyTrackingVM.BusinessUnitListForFilters(mappedBuList);
                        //Main tain this list to retain the org filters on deselection of applicability filters
                        SurveyTrackingVM.FinalOrgFilterList(mappedBuList);

                    }
                    else {
                        SurveyTrackingVM.BusinessUnitListForFilters([]);
                        mappedBuList = $.map(SurveyTrackingVM.BusinessUnitListForFiltersDUP(), function (result) {
                            return new BusinessUnitModelDUP(result);
                        });
                        SurveyTrackingVM.BusinessUnitListForFilters(mappedBuList);
                        SurveyTrackingVM.FinalOrgFilterList(mappedBuList);
                    }
                    SetFilterSelection();
                }
                else if (isNaN(parseInt(selectedSubOrgLevelID)) && SurveyTrackingVM.SelectedCheckedList().length == 0) {
                    BUselected = event.currentTarget.id.substr(event.currentTarget.id.indexOf("BU") + 2);

                    for (var i = 0; i < SurveyTrackingVM.BusinessUnitListDUP().length; i++) {
                        if (SurveyTrackingVM.BusinessUnitListDUP()[i].BusinessUnitId() == BUselected) {
                            if (event.currentTarget.checked) {
                                $("#sublevelBU" + BUselected).prop("checked", true);
                                $('.fa-check.' + BUselected).css({ 'display': 'inline-block' });

                                SurveyTrackingVM.SelectedCheckedBUList.push({
                                    SubLevelId: SurveyTrackingVM.BusinessUnitListDUP()[i].BusinessUnitId(),
                                    SubLevelName: SurveyTrackingVM.BusinessUnitListDUP()[i].BusinessUnitName()
                                });
                            }
                            else {
                                $("#sublevelBU" + BUselected).prop("checked", false);
                                $('.fa-check.' + BUselected).css({ 'display': 'none' });
                                if (SurveyTrackingVM.SelectedCheckedBUList().length > 0) {
                                    SurveyTrackingVM.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == SurveyTrackingVM.BusinessUnitListDUP()[i].BusinessUnitId() })
                                }
                            }
                        }
                    }

                    if (SurveyTrackingVM.SelectedCheckedBUList().length > 0) {
                        //Logic to re-set the BU list
                        SurveyTrackingVM.BusinessUnitListForFilters([]);

                        var mappedBuList = $.map(SurveyTrackingVM.BusinessUnitListDUP(), function (result) {
                            for (var m = 0; m < SurveyTrackingVM.SelectedCheckedBUList().length; m++) {
                                if (result.BusinessUnitId() == SurveyTrackingVM.SelectedCheckedBUList()[m].SubLevelId)
                                    return new BusinessUnitModelDUP(result);
                            }
                        });
                        SurveyTrackingVM.BusinessUnitListForFilters(mappedBuList);
                    }
                    else {
                        SurveyTrackingVM.BusinessUnitListForFilters([]);
                        var mappedBuList = $.map(SurveyTrackingVM.BusinessUnitListForFiltersDUP(), function (result) {
                            return new BusinessUnitModelDUP(result);
                        });
                        SurveyTrackingVM.BusinessUnitListForFilters(mappedBuList);
                        SurveyTrackingVM.FinalOrgFilterList(mappedBuList);
                    }
                    SetBUFilterSelection();
                }
                //Set count of BU's selected
                if (SurveyTrackingVM.BusinessUnitListForFilters().length > 0) {
                    SurveyTrackingVM.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return SurveyTrackingVM.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    SurveyTrackingVM.BusinessUnitListForFilters(SurveyTrackingVM.DistinctFileredBUs());
                }

                if (SurveyTrackingVM.SelectedCheckedList().length > 0 || SurveyTrackingVM.SelectedCheckedBUList().length > 0)
                    SurveyTrackingVM.NumberOfBUsSelected(SurveyTrackingVM.BusinessUnitListForFilters().length);
                else
                    SurveyTrackingVM.NumberOfBUsSelected(0);
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source:  SubCheckboxSelected function in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function SetFilterSelection() {
            try {
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                //Mark Org levels filter seletion
                var contentHtml = "";
                for (var k = 0; k < SurveyTrackingVM.SelectedCheckedList().length; k++) {
                    contentHtml += '<div id="DynamicOptedFilters_' + SurveyTrackingVM.SelectedCheckedList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">' + SurveyTrackingVM.SelectedCheckedList()[k].OrgLevelName + '</span> : ' + SurveyTrackingVM.SelectedCheckedList()[k].SubLevelName + '<span class="f-clear" id="ClearFilterText_' + SurveyTrackingVM.SelectedCheckedList()[k].SubLevelId + '" data-bind="click:ClearOrgFilterSelection"><i class="demo-icon icon-cross_special"></i></span></span></div>';
                }
                document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
                for (var k = 0; k < SurveyTrackingVM.SelectedCheckedList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterText_' + SurveyTrackingVM.SelectedCheckedList()[k].SubLevelId), { click: SurveyTrackingVM.ClearOrgFilterSelection }, SurveyTrackingVM);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetFilterSelection() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function SetBUFilterSelection() {
            try {
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";

                var contentHtml = "";
                for (var k = 0; k < SurveyTrackingVM.SelectedCheckedBUList().length; k++) {
                    contentHtml += '<div id="DynamicBUOptedFilters_' + SurveyTrackingVM.SelectedCheckedBUList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">BU </span> : ' + SurveyTrackingVM.SelectedCheckedBUList()[k].SubLevelName + '<span id="ClearFilterTextBU_' + SurveyTrackingVM.SelectedCheckedBUList()[k].SubLevelId + '" class="font-weight-bold bg-transparent mb-2" data-bind="click:ClearBUFilterSelection"><i class="demo-icon icon-cross_special"></i> </span></span></div>';
                }

                document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
                for (var k = 0; k < SurveyTrackingVM.SelectedCheckedBUList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterTextBU_' + SurveyTrackingVM.SelectedCheckedBUList()[k].SubLevelId), { click: SurveyTrackingVM.ClearBUFilterSelection }, SurveyTrackingVM);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetBUFilterSelection() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function ClearOrgFilterSelection(data, event) {
            try {
                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
                document.getElementById('DynamicOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

                $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
                if (SurveyTrackingVM.SelectedCheckedList().length > 0) {
                    SurveyTrackingVM.SelectedCheckedList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID });
                }

                //Logic to re-set the BU list
                SurveyTrackingVM.BusinessUnitListForFilters([]);
                if (SurveyTrackingVM.SelectedCheckedList().length > 0) {
                    var mappedBuList = $.map(SurveyTrackingVM.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < SurveyTrackingVM.SelectedCheckedList().length; m++) {
                            if (result.SubLevelId() == SurveyTrackingVM.SelectedCheckedList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    SurveyTrackingVM.BusinessUnitListForFilters(mappedBuList);
                    //Main tain this list to retain the org filters on deselection of applicability filters
                    SurveyTrackingVM.FinalOrgFilterList(mappedBuList);

                }
                else {
                    SurveyTrackingVM.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(SurveyTrackingVM.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    SurveyTrackingVM.BusinessUnitListForFilters(mappedBuList);
                    SurveyTrackingVM.FinalOrgFilterList(mappedBuList);
                    $('#BUFilterError').hide();
                }
                //Set count of BU's selected
                if (SurveyTrackingVM.BusinessUnitListForFilters().length > 0) {
                    SurveyTrackingVM.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return SurveyTrackingVM.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    SurveyTrackingVM.BusinessUnitListForFilters(SurveyTrackingVM.DistinctFileredBUs());
                }

                if (SurveyTrackingVM.SelectedCheckedList().length > 0 || SurveyTrackingVM.SelectedCheckedBUList().length > 0)
                    SurveyTrackingVM.NumberOfBUsSelected(SurveyTrackingVM.BusinessUnitListForFilters().length);
                else
                    SurveyTrackingVM.NumberOfBUsSelected(0);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function ClearBUFilterSelection(data, event) {
            try {
                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
                document.getElementById('DynamicBUOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

                $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
                if (SurveyTrackingVM.SelectedCheckedBUList().length > 0) {
                    SurveyTrackingVM.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID })
                }

                //Logic to re-set the BU list
                SurveyTrackingVM.BusinessUnitListForFilters([]);
                if (SurveyTrackingVM.SelectedCheckedBUList().length > 0) {
                    var mappedBuList = $.map(SurveyTrackingVM.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < SurveyTrackingVM.SelectedCheckedBUList().length; m++) {
                            if (result.BusinessUnitId() == SurveyTrackingVM.SelectedCheckedBUList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    SurveyTrackingVM.BusinessUnitListForFilters(mappedBuList);

                }
                else {
                    SurveyTrackingVM.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(SurveyTrackingVM.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    SurveyTrackingVM.BusinessUnitListForFilters(mappedBuList);

                    $('#OrgFilterError').hide();
                }
                //Set count of BU's selected
                if (SurveyTrackingVM.BusinessUnitListForFilters().length > 0) {
                    SurveyTrackingVM.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return SurveyTrackingVM.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    SurveyTrackingVM.BusinessUnitListForFilters(SurveyTrackingVM.DistinctFileredBUs());
                }
                if (SurveyTrackingVM.SelectedCheckedList().length > 0 || SurveyTrackingVM.SelectedCheckedBUList().length > 0)
                    SurveyTrackingVM.NumberOfBUsSelected(SurveyTrackingVM.BusinessUnitListForFilters().length);
                else
                    SurveyTrackingVM.NumberOfBUsSelected(0);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearBUFilterSelection() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function SetStatusFilterSelection() {
            try {
                document.getElementById('DynamicStatusOptedFilters').innerHTML = "";

                var contentHtml = "";
                for (var k = 0; k < SurveyTrackingVM.SelectedCheckedStatusList().length; k++) {
                    contentHtml += '<div id="DynamicStatusFilters_' + SurveyTrackingVM.SelectedCheckedStatusList()[k].Process_Id + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">Status </span> : ' + SurveyTrackingVM.SelectedCheckedStatusList()[k].Process_Name + '<span  class="f-clear" id="ClearFilterTextStatus_' + SurveyTrackingVM.SelectedCheckedStatusList()[k].Process_Id + '" data-bind="click:ClearStatusFilterSelection"><i class="demo-icon icon-cross_special"></i>  </span></span></div>';
                }

                document.getElementById('DynamicStatusOptedFilters').innerHTML = contentHtml;
                for (var k = 0; k < SurveyTrackingVM.SelectedCheckedStatusList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterTextStatus_' + SurveyTrackingVM.SelectedCheckedStatusList()[k].Process_Id), { click: SurveyTrackingVM.ClearStatusFilterSelection }, SurveyTrackingVM);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetStatusFilterSelection() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function SetSurveyTypeFilterSelection() {
            try {
                document.getElementById('DynamicSurveyTypeOptedFilters').innerHTML = "";

                var contentHtml = "";
                for (var k = 0; k < SurveyTrackingVM.SelectedCheckedSurveyTypeList().length; k++) {
                    contentHtml += '<div id="DynamicSurveyTypeFilters_' + SurveyTrackingVM.SelectedCheckedSurveyTypeList()[k].SurveyType_Id + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">Survey Type </span> : ' + SurveyTrackingVM.SelectedCheckedSurveyTypeList()[k].SurveyType_Name + '<span class="f-clear" id="ClearFilterTextSurveyType_' + SurveyTrackingVM.SelectedCheckedSurveyTypeList()[k].SurveyType_Id + '" data-bind="click: ClearSurveyTypeFilterSelection"><i class="demo-icon icon-cross_special"></i> </span></span></div>';
                }

                document.getElementById('DynamicSurveyTypeOptedFilters').innerHTML = contentHtml;
                for (var k = 0; k < SurveyTrackingVM.SelectedCheckedSurveyTypeList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterTextSurveyType_' + SurveyTrackingVM.SelectedCheckedSurveyTypeList()[k].SurveyType_Id), { click: SurveyTrackingVM.ClearSurveyTypeFilterSelection }, SurveyTrackingVM);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetSurveyTypeFilterSelection() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function ClearStatusFilterSelection(data, event) {
            try {
                var ProcessId = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
                document.getElementById('DynamicStatusFilters_' + ProcessId).innerHTML = "";

                $('.fa-check.' + ProcessId).css({ 'display': 'none' });
                if (SurveyTrackingVM.SelectedCheckedStatusList().length > 0) {
                    SurveyTrackingVM.SelectedCheckedStatusList.remove(function (item) { return item.Process_Id == ProcessId })
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearStatusFilterSelection() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function ClearSurveyTypeFilterSelection(data, event) {
            try {
                var ProcessId = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
                document.getElementById('DynamicSurveyTypeFilters_' + ProcessId).innerHTML = "";

                $('.fa-check.' + ProcessId).css({ 'display': 'none' });
                if (SurveyTrackingVM.SelectedCheckedSurveyTypeList().length > 0) {
                    SurveyTrackingVM.SelectedCheckedSurveyTypeList.remove(function (item) { return item.SurveyType_Id == ProcessId })
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearSurveyTypeFilterSelection() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Set Methods

        function finalizeSurvey(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/FinalizeSurvey?SurveyId=" + data.SurveyId(),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source: ajax call in finalizeSurvey() in SurveyTracking.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult == "1") {
                        data.finalizeSurvey("YES");
                        logger.logSuccess((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('FinalizeSuccessMesssage') == -1) ? 'Successfully finalized the survey.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('FinalizeSuccessMesssage')].Name(), 'Success', system.getModuleId(SurveyTrackingVM), true);
                    }
                    else if (jsonResult.substring(0, 3) == "INC") {
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                            ? jsonResult + " - An error occurred. Please contact your Application Administrator."
                            : jsonResult + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                            [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                    else
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred while finalizing the survey.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                }
                catch (e) {
                    var msg = 'Exception' + e + ' || source:  ajaxSuccess() in finalizeSurvey() in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' || Source: ajaxFail in finalizeSurvey() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in finalizeSurvey() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }
        }

        function SetSurveyLevelComments(SurveyId, EventId, WPECommentText, SurveyType) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/SetSurveyLevelComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        Draft: parseInt(SurveyId), AssessmentProfileId: parseInt(SurveyTrackingVM.CurrentProfileOfAssessmentId()),
                        EventId: parseInt(EventId), CommentId: -1, RoleId: SurveyTrackingVM.RoleValue(), CommentText: WPECommentText,
                        CommentType: 'APBC', SurveyType: SurveyType
                    }),
                    type: "POST",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetSurveyLevelComments() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.substring(0, 3) == "INC") {
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                            ? jsonResult + " - An error occurred. Please contact your Application Administrator."
                            : jsonResult + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                            [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                    else if (jsonResult != null && jsonResult == 1) {
                        // success case
                    }
                    else {
                        var msg = (!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logError(jsonResult[0].SurveyStatus + " - " + msg, 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SetSurveyLevelComments() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetSurveyLevelComments() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in SetSurveyLevelComments() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion

        //#region Excel Exports - Reports

        function ExportSurveyToExcel(data, event) {
            try {
                if (data.SurveyCode() == "PCS") {
                    var UserString = (!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('AssignedUsersHeading') == -1) ? 'Assigned Users:' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('AssignedUsersHeading')].Name();
                    var completionDue = (!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('CompletionDueDate') == -1) ? 'Completion Due Date: ' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('CompletionDueDate')].Name();

                    if (data.AssignedUser() != null || data.AssignedUser() != "")
                        UserString = UserString + data.AssignedUser().replace(/(<p>|<\/p>|<strong class='lbl-space'>|<strong>|<\/strong>|<em>|<\/em>|<u>|<\/u>|<ol>|<\/ol>|<ul>|<\/ul>|<li>|<\/li>)/gi, "").replace(/(\r\n|\n|\r)/gm, " ");
                    var payLoadRR = {
                        t: appsecurity.getAuthenticationInfo(), SurveyID: data.SurveyId()
                        , SurveyName: $('<div/>').html(data.SurveyName()).text(), DueDate: 'Completion Due Date: ' + data.DueDate(), UserList: UserString.toString(), SurveyProfileID: data.SP_UID()
                    };
                    utils.postAndRedirect(rootPath + "/FileDownload/ExportExcelRRSurvey", payLoadRR, '_blank');
                }
                else {
                    var BUNameVar = SurveyTrackingVM.BUTitle() + ": " + data.BuName();
                    var BUlistString = data.BUListString();
                    var UserString = (!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('AssignedUsersHeading') == -1) ? 'Assigned Users:' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('AssignedUsersHeading')].Name();
                    var completionDue = (!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('CompletionDueDate') == -1) ? 'Completion Due Date: ' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('CompletionDueDate')].Name();

                    if (data.AssignedUser() != null || data.AssignedUser() != "")
                        UserString = UserString + data.AssignedUser().replace(/(<p>|<\/p>|<strong class='lbl-space'>|<strong>|<\/strong>|<em>|<\/em>|<u>|<\/u>|<ol>|<\/ol>|<ul>|<\/ul>|<li>|<\/li>)/gi, "").replace(/(\r\n|\n|\r)/gm, " ");

                    var payLoad = {
                        t: appsecurity.getAuthenticationInfo(), BussinessUnitId: data.BuId(), SurveyID: data.SP_UID(), SurveyType: data.SurveyType(), SurveyName: $('<div/>').html(data.SurveyName()).text(),
                        BUName: BUNameVar.toString(), BUOrgList: BUlistString.toString(), UserList: UserString.toString(), DueDate: completionDue + data.DueDate()
                    };

                    if (data.SurveyCode() == "QTDR") {
                        utils.postAndRedirect(rootPath + "/FileDownload/ExportExcelSurvey", payLoad, '_blank');
                    }
                    else if (data.SurveyCode() == "QLDR") {
                        utils.postAndRedirect(rootPath + "/FileDownload/ExportExcelQualSurvey", payLoad, '_blank');
                    }
                    else if (data.SurveyCode() == "CDR") {
                        utils.postAndRedirect(rootPath + "/FileDownload/GetControlsExcel", payLoad, '_blank');
                    }
                }

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ExportSurveyToExcel() in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function DownloadSurveyResponsderReviewerReport() {
            try {
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(),
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadSurveyResponderReviewerReport", payLoad, '_blank');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DownloadSurveyResponsderReviewerReport() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function DownloadSurveyDocuments(data, event) {
            try {
                if (data.PPDISPNAME() == 'PCS') {
                    BuId = data.BuId();
                    SurveyProfileId = data.SP_UID();
                    SurveyName = data.SurveyName();
                    SurveyTrackingVM.SurveyType('PCS');
                    return $.ajax({
                        url: "/api/Survey/DownloadSurveyDocumentsRR",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders(),
                        data: {
                            BusinessId: BuId, SurveyProfileId: SurveyProfileId, SurveyName: data.SurveyName()
                        }
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail)
                }
                else {
                    BuId = data.BuId();
                    SurveyProfileId = data.SP_UID();
                    SurveyName = data.SurveyName();
                    return $.ajax({
                        url: "/api/Survey/DownloadSurveyDocuments",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders(),
                        data: {
                            BusinessId: data.BuId(), SurveyProfileId: SurveyProfileId, SurveyName: data.SurveyName()
                        }
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail)
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' || Source: ajax call in DownloadSurveyDocuments() in SurveyTracking.js';
                logger.logMessage(msg)
            }


            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult.length > 0) {
                            if (jsonResult[0].ErrorId == -99) {
                                logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                                    ? jsonResult[0].ErrorName + " - An error occurred. Please contact your Application Administrator."
                                    : jsonResult[0].ErrorName + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                                    [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                            }
                            else {
                                var payLoad = {
                                    t: appsecurity.getAuthenticationInfo(), BusinessId: BuId, SurveyProfileId: SurveyProfileId, SurveyName: SurveyName
                                };
                                if (SurveyTrackingVM.SurveyType() == 'PCS') {
                                    utils.postAndRedirect(rootPath + "/FileDownload/DownloadSurveyDocumentsRR", payLoad, '_blank');
                                }
                                else {
                                    utils.postAndRedirect(rootPath + "/FileDownload/DownloadSurveyDocuments", payLoad, '_blank');
                                }
                            }
                        }
                        else {
                            logger.logWarning('There are no uploaded files for this survey.', 'Warning', system.getModuleId(SurveyTrackingVM), true);
                        }
                    }

                    else {
                        logger.logWarning('There are no uploaded files for this survey.', 'Warning', system.getModuleId(SurveyTrackingVM), true);
                    }
                }

                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: DownloadSurveyDocuments() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    var msg = null;
                    if (error.status == 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DownloadSurveyDocuments() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    msg = 'Exception: ' + e + ' | Source: ajaxFail in DownloadSurveyDocuments() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            };
        }

        //#endregion

        //#region Pushback related Methods

        function PushbackPopUpClick(data, event) {
            try {
                $('#ActionsPopUp').modal('show');
                SurveyTrackingVM.SelectedSurveyId(data.SurveyId());
                SurveyTrackingVM.SelectedSurveyName(data.SurveyName());
                if (data.PPDISPNAME() == "PCS") {
                    PushBackRR(data);
                }
                else {
                    Pushback(data, event);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PushbackPopUpClick in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function PushBackRR(data, event) {
            try {
                SurveyTrackingVM.SurveyUIDPushback(data.SurveyId());
                var SurveyType;
                SurveyType = "PCS";
                SurveyTrackingVM.SurveyType(SurveyType);

                $.ajax({
                    url: "/api/Survey/GetPossiblePushbackListRR",
                    data: { SurveyId: data.SurveyId(), SurveyType: SurveyType },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in PushBackRR() method in SurveyTracking.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    $('#ActionsPopUp').show();
                    $('#ActionsMain').hide();
                    $('#loadingImgMainRC1').hide();
                    SurveyTrackingVM.PossiblePushbackList([]);
                    if (jsonResult != null) {
                        if (jsonResult.length > 0 && jsonResult[0].EVENT_ID == -99) {
                            logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                                ? jsonResult[0].EVENT_NAME + " - An error occurred. Please contact your Application Administrator."
                                : jsonResult[0].EVENT_NAME + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                                [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                        }
                        else {
                            var mappedActionsList = $.map(jsonResult, function (result) {
                                return new PushBackModel(result);
                            });
                            SurveyTrackingVM.PossiblePushbackList(mappedActionsList);
                        }
                    }
                    else {
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred.Please contact your Application Administrator.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                    $('#ActionsMain').show();
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in PushBackRR() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    var msg = null;
                    if (error.status == 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in PushBackRR() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    msg = 'Exception: ' + e + ' | Source: ajaxFail in PushBackRR() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            };
        }

        function Pushback(data, event) {
            try {
                SurveyTrackingVM.SurveyUIDPushback(data.SurveyId());
                var SurveyType;
                if (data.PPDISPNAME() == "SUR" || data.PPDISPNAME() == "PCS") {
                    if (data.PPDISPNAME() == "SUR") {
                        SurveyType = "SURVEY";
                        SurveyTrackingVM.SurveyType(SurveyType);
                    }
                    else if (data.PPDISPNAME() == "PCS") {
                        SurveyType = "PCS";
                        SurveyTrackingVM.SurveyType(SurveyType);
                    }
                    $.ajax({
                        url: "/api/Survey/GetPossiblePushbackList",
                        data: { SurveyId: data.SurveyId(), SurveyType: SurveyType },
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders()
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
                else {
                    SurveyType = "SOC";
                    SurveyTrackingVM.SurveyType(SurveyType);
                    $.ajax({
                        url: "/api/Survey/GetPossiblePushbackListSocialization",
                        data: { DeRatUid: data.SurveyId() },
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders()
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in Pushback() method in SurveyTracking.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    $('#ActionsPopUp').show();
                    $('#ActionsMain').hide();
                    $('#loadingImgMainRC1').hide();
                    SurveyTrackingVM.PossiblePushbackList([]);
                    if (jsonResult != null) {
                        if (jsonResult.length > 0 && jsonResult[0].EVENT_ID == -99) {
                            logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                                ? jsonResult[0].EVENT_NAME + " - An error occurred. Please contact your Application Administrator."
                                : jsonResult[0].EVENT_NAME + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                                [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                        }
                        else {
                            var mappedActionsList = $.map(jsonResult, function (result) {
                                return new PushBackModel(result);
                            });
                            SurveyTrackingVM.PossiblePushbackList(mappedActionsList);
                        }
                    }
                    else {
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred.Please contact your Application Administrator.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                    $('#ActionsMain').show();
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in Pushback() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    var msg = null;
                    if (error.status == 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in Pushback() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    msg = 'Exception: ' + e + ' | Source: ajaxFail in Pushback() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            };
        }

        function PushbackTheSurveyAjax(data, event) {
            try {
                if (SurveyTrackingVM.SurveyType() == "PCS") {
                    PushbackTheSurveyAjaxRR(data, event);
                }
                else {
                    var EventId = 0;
                    EventId = $("input[name='rdbAction']:checked").val();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    var SurveyId = SurveyTrackingVM.SelectedSurveyId();
                    var commentText = "";
                    for (var i = 0; i < data.PossiblePushbackList().length; i++) {
                        if (data.PossiblePushbackList()[i].EVENT_ID() == parseInt(EventId)) {
                            commentText = data.PossiblePushbackList()[i].COMMENT_TEXT();
                            break;
                        }
                    }
                    SurveyTrackingVM.CommentText(commentText);
                    var SurveyType;
                    if (SurveyTrackingVM.SurveyType() == "SURVEY") {

                        SurveyType = "SURVEY";
                        headers.__RequestVerificationToken = csrfToken;
                        $.ajax({
                            url: "/api/Survey/PushbackQuestionnaire?EventId=" + EventId + "&SurveyId=" + SurveyTrackingVM.SelectedSurveyId() + "&SurveyType=" + SurveyType,
                            headers: headers,
                            type: "POST"
                        })
                            .success(ajaxSuccess)
                            .fail(ajaxFail);
                    }
                    else {
                        SurveyType = "SOC";
                        headers.__RequestVerificationToken = csrfToken;
                        $.ajax({
                            url: "/api/Survey/PushbackSocializationSurvey?EventId=" + EventId + "&DeRatUid=" + SurveyTrackingVM.SelectedSurveyId(),
                            headers: headers,
                            type: "POST"
                        })
                            .success(ajaxSuccess)
                            .fail(ajaxFail);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source: ajax call in PushbackTheSurveyAjax() in SurveyTracking.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult.length > 0 && jsonResult[0].ErrorId == -99) {
                            logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                                ? jsonResult[0].ErrorCode + " - An error occurred. Please contact your Application Administrator."
                                : jsonResult[0].ErrorCode + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                                [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                        }
                        else if (jsonResult.length > 0 && jsonResult[0].Flag == 0) {
                            logger.logSuccess((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('PushedBackSuccessMessage') == -1) ? 'The Questionnaire has been pushed back successfully.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('PushedBackSuccessMessage')].Name(), 'Success', system.getModuleId(SurveyTrackingVM), true);
                            if (SurveyType == "SURVEY") {
                                SetSurveyLevelComments(SurveyTrackingVM.SelectedSurveyId(), EventId, SurveyTrackingVM.CommentText(), "SUR");
                            }
                            else {
                                SetSurveyLevelComments(SurveyTrackingVM.SelectedSurveyId(), EventId, SurveyTrackingVM.CommentText(), "SOC");
                            }
                            $('#ActionsPopUp').modal('hide');
                            ApplyFilters();
                        }
                        else
                            logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred.Please contact your Application Administrator.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                    else
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred.Please contact your Application Administrator.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                }
                catch (e) {
                    var msg = 'Exception' + e + ' || source:  ajaxSuccess() in PushbackTheSurveyAjax() in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' || Source: ajaxFail in PushbackTheSurveyAjax() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in PushbackTheSurveyAjax() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }
        }

        function PushbackTheSurveyAjaxRR(data, event) {
            try {
                var EventId = 0;
                EventId = $("input[name='rdbAction']:checked").val();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();

                var SurveyId = SurveyTrackingVM.SelectedSurveyId();

                var commentText = "";

                for (var i = 0; i < data.PossiblePushbackList().length; i++) {
                    if (data.PossiblePushbackList()[i].EVENT_ID() == parseInt(EventId)) {
                        commentText = data.PossiblePushbackList()[i].COMMENT_TEXT();
                        break;
                    }
                }
                SurveyTrackingVM.CommentText(commentText);
                var SurveyType;
                if (SurveyTrackingVM.SurveyType() == "PCS")
                    SurveyType = "PCS";

                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/PushbackQuestionnaireRR?EventId=" + EventId + "&SurveyId=" + SurveyTrackingVM.SelectedSurveyId() + "&SurveyType=" + SurveyType,
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

            }
            catch (e) {
                var msg = 'Exception' + e + ' || source: ajax call in PushbackTheSurveyAjaxRR() in SurveyTracking.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult.length > 0 && jsonResult[0].ErrorId == -99) {
                            logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                                ? jsonResult[0].ErrorCode + " - An error occurred. Please contact your Application Administrator."
                                : jsonResult[0].ErrorCode + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                                [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                        }
                        else if (jsonResult.length > 0 && jsonResult[0].Flag == 0) {
                            logger.logSuccess((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('PushedBackSuccessMessage') == -1) ? 'The Questionnaire has been pushed back successfully.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('PushedBackSuccessMessage')].Name(), 'Success', system.getModuleId(SurveyTrackingVM), true);
                            if (SurveyType == "SURVEY") {
                                SetSurveyLevelComments(SurveyTrackingVM.SelectedSurveyId(), EventId, SurveyTrackingVM.CommentText(), "SUR");
                            }
                            else if (SurveyType == "PCS") {
                                SetSurveyLevelComments(SurveyTrackingVM.SelectedSurveyId(), EventId, SurveyTrackingVM.CommentText(), "PCS");
                            }
                            else {
                                SetSurveyLevelComments(SurveyTrackingVM.SelectedSurveyId(), EventId, SurveyTrackingVM.CommentText(), "SOC");
                            }
                            $('#ActionsPopUp').modal('hide');
                            ApplyFilters();
                        }
                        else
                            logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred.Please contact your Application Administrator.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                    else
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred.Please contact your Application Administrator.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                }
                catch (e) {
                    var msg = 'Exception' + e + ' || source:  ajaxSuccess() in PushbackTheSurveyAjaxRR() in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' || Source: ajaxFail in PushbackTheSurveyAjaxRR() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in PushbackTheSurveyAjaxRR() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }
        }

        function btnCloseActionPopup() {
            try {
                $('#ActionsPopUp').modal('hide');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: btnCloseActionPopup() in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Charts in Filter

        //Draw Piechart for fewer process points
        function DrawPieChartForProcessPoints() {
            try {
                var sum = 0;
                for (var i = 1; i < SurveyTrackingVM.SurveyProcessPointsList().length; i++) {
                    var percent = parseInt(Math.round((SurveyTrackingVM.OverallMetrics()[i] / SurveyTrackingVM.OverallMetrics()[0]) * 100));
                    if (isNaN(percent)) {
                        percent = '-';
                    }
                    sum = sum + percent;
                    var chartbody = '<span id=piechart' + i + ' class="chart" data-percent="' + percent + '">' +
                        ' <span class="percent">' + percent + '</span></span>';
                    document.getElementById('chart' + i).innerHTML = chartbody;

                }
                for (var i = 1; i < SurveyTrackingVM.SurveyProcessPointsList().length; i++) {
                    $(function () {
                        $('#piechart' + i).easyPieChart({
                            barColor: '#ffffff',
                            trackColor: 'rgba(255,255,255,0.3)',
                            easing: 'easeOutBounce'
                        });
                        var chart = window.chart = $('#chart' + i).data('easyPieChart');
                    });
                }
                var diff = sum - 100;
                for (var i = SurveyTrackingVM.SurveyProcessPointsList().length - 1; i >= 1; i--) {
                    if (parseInt($('#piechart' + i + ' span').text()) != 0 && parseInt($('#piechart' + i + ' span').text()) > diff) {
                        var textvalue = parseInt($('#piechart' + i + ' span').text())
                        $('#piechart' + i + ' span').text(textvalue - diff);
                        break;
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DrawPieChartForProcessPoints() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function FiltersForGraphs(ProcessId) {
            try {
                $('#SurDetailTabDiv').hide();
                $('#loadingImgSurveyTracking').show();

                SurveyTrackingVM.SelectedBUs('');
                var SelectedBUsString = "";

                if (SurveyTrackingVM.SelectedCheckedList().length > 0 || SurveyTrackingVM.SelectedCheckedBUList().length > 0) {
                    for (var i = 0; i < SurveyTrackingVM.BusinessUnitListForFilters().length; i++) {
                        if (SelectedBUsString === "")
                            SelectedBUsString = SurveyTrackingVM.BusinessUnitListForFilters()[i].BusinessUnitId().toString();
                        else
                            SelectedBUsString += "," + SurveyTrackingVM.BusinessUnitListForFilters()[i].BusinessUnitId().toString();
                    }
                }

                var SelectedSurveyTypeFilterString = "";
                for (var i = 0; i < SurveyTrackingVM.SelectedCheckedSurveyTypeList().length; i++) {
                    if (SelectedSurveyTypeFilterString === "")
                        SelectedSurveyTypeFilterString = SurveyTrackingVM.SelectedCheckedSurveyTypeList()[i].SurveyType_Id.toString();
                    else
                        SelectedSurveyTypeFilterString += "," + SurveyTrackingVM.SelectedCheckedSurveyTypeList()[i].SurveyType_Id.toString();
                }

                SurveyTrackingVM.SelectedBUs(SelectedBUsString);

                if (SurveyTrackingVM.SelectedBUs() === undefined)
                    SurveyTrackingVM.SelectedBUs("");

                if (SurveyTrackingVM.SelectedFilters() === undefined)
                    SurveyTrackingVM.SelectedFilters("");

                SurveyTrackingVM.SelectedSurveyTypeFilters(SelectedSurveyTypeFilterString);

                if (SurveyTrackingVM.SelectedSurveyTypeFilters() === undefined)
                    SurveyTrackingVM.SelectedSurveyTypeFilters("");

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/PostSurveyTrackingDetailstable",
                    headers: headers,
                    type: "POST",
                    applicationType: 'application/json',
                    dataType: 'json',
                    data: { SelectedBUs: SurveyTrackingVM.SelectedBUs(), SelectedFilters: ProcessId.toString(), SelectedSurveyProfiles: SurveyTrackingVM.SelectedSurveyTypeFilters(), GetDataType: SurveyTrackingVM.NavPillId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

            }
            catch (e) {
                var msg = 'Exception' + e + ' || source: ajax call in FiltersForGraphs() in SurveyTracking.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {

                    $('#loadingImgSurveyTracking').hide();
                    $('#SurDetailTabDiv').show();
                    if (jsonResult.ErrorID == -1) {
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                            ? jsonResult.ErrorName + " - An error occurred. Please contact your Application Administrator."
                            : jsonResult.ErrorName + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()
                            [SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                    }
                    else {
                        var SurveyTrackingData = $.map(jsonResult.SurveyTrackingData, function (result) {
                            return new SurveytrackingModel(result);
                        });

                        var p = $('#tblSurveyTracking').DataTable().page.info().page
                        RaTableObj.destroy();
                        $('#tblSurveyTracking tbody tr').remove();
                        SurveyTrackingVM.SurveyTrackingList([]);
                        SurveyTrackingVM.SurveyTrackingList(SurveyTrackingData);

                        RaTableObj = $('#tblSurveyTracking').DataTable({
                            "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                            "pageLength": 10,
                            "language": {
                                searchPlaceholder: "Search"
                            },
                            "searchDelay": 350,
                            "stateSave": true,
                            "initComplete": function () {
                                this.api().columns().every(function () {
                                    var column = this;
                                    if (column[0][0] != '0' && column[0][0] != '5' && column[0][0] != '6') {
                                        var select = $('<select style=" width:100%; overflow: hidden;"> <option value="">All</option></select>')
                                            .appendTo($(column.footer()).empty())
                                            .on('change', function () {
                                                var val = $.fn.dataTable.util.escapeRegex(
                                                    $(this).val()
                                                );

                                                column
                                                    .search(val ? '^' + val + '$' : '', true, false)
                                                    .draw();
                                            });

                                        column.data().unique().sort().each(function (d, j) {
                                            select.append('<option value="' + d + '">' + d + '</option>')
                                        });
                                    }
                                });
                            }
                        });

                        closeSideNav();

                        if (SurveyTrackingVM.SelectedSurveyTypeFilters() == "" && SurveyTrackingVM.SelectedFilters() == "" && SurveyTrackingVM.SelectedBUs() == "") {
                            SurveyTrackingVM.AreFiltersApplied(0);
                        }
                        else {
                            SurveyTrackingVM.AreFiltersApplied(1);
                        }

                        RaTableObj.page(p).draw(false);
                        SurveyTrackingVM.ApplyFiltersclickedcount(SurveyTrackingData.length);

                        var ProcessPointsLevels = $.map(jsonResult.ProcessPointsData, function (result) {
                            if (result.PROCESS_ID != 0)
                                return new ProcessPointsModel(result);
                        });
                        SurveyTrackingVM.StatusFilterValues(ProcessPointsLevels);

                        var mappedSurveyProcessList = $.map(jsonResult.ProcessPointsData, function (result) {
                            return new SurveyProcessModel(result);
                        });
                        SurveyTrackingVM.SurveyProcessPointsList(mappedSurveyProcessList);
                        TotalMetrics = [];
                        for (var i = 0; i < SurveyTrackingVM.SurveyProcessPointsList().length; i++) {
                            TotalMetrics.push(parseInt(SurveyTrackingVM.SurveyProcessPointsList()[i].COUNT()));
                        }
                        SurveyTrackingVM.OverallMetrics(TotalMetrics);
                        BindPieChartForProcessPoints();
                        DrawPieChartForProcessPoints();
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' || source: ajaxSuccess in FiltersForGraphs() in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' || Source: ajaxFail in FiltersForGraphs() method in SurveyTracking.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' || Source: ajaxFail in FiltersForGraphs() method in SurveyTracking.js';
                    logger.logMessage(msg);
                }
            }

        }

        //Bind Dynamic Html - PieChart for few process points
        function BindPieChartForProcessPoints() {
            try {
                var DynamicHtml = "";

                DynamicHtml += "<div class='col-lg-10'>";

                DynamicHtml += "<div class='MultiCarousel' data-items='1, 3, 5, 6' data-slide='1' id='MultiCarousel' data-interval='1000'><div class='MultiCarousel-inner'>"
                for (var i = 1; i < SurveyTrackingVM.SurveyProcessPointsList().length; i++) {
                    DynamicHtml += "<div class='item'>" +
                        "<div class='pad-15 stats-overview stat-block' style='background-color:" + SurveyTrackingVM.SurveyProcessPointsList()[i].COLORCODE() + "'>" +
                        "   <div id='chart" + i + "'>" +

                        "</div>" +
                        " </div>" +
                        `<div class="state-lbl headcoltest" id="headcoltest_` + i + `" data-bind="click: function (data, event) { $root.FiltersForGraphs(` + SurveyTrackingVM.SurveyProcessPointsList()[i].PROCESS_ID() + `)}" type='button'> <span class='state-number'>` + SurveyTrackingVM.SurveyProcessPointsList()[i].COUNT() + `</span>` + SurveyTrackingVM.SurveyProcessPointsList()[i].PROCESS_POINT() + `</div>` +

                        "</div>";
                }

                DynamicHtml += "</div>"
                DynamicHtml += "<span class='leftLst'><i class='demo-icon icon-simple_arrow_left_special'></i> </span><span class='rightLst'><i class='demo-icon icon-simple_arrow_right_special'></i></span>"
                DynamicHtml += "</div></div>"

                DynamicHtml += "<div class='col-lg-2'>";

                DynamicHtml += '<div class="total" id="TotalST" type="button" data-bind="click: $root.ClearAllBuFilters"><div class="stats-overview stat-block totalSurvey">' +
                    " <div class='details'>" +
                    "<div class='numbers'" +
                    "<label>" + SurveyTrackingVM.SurveyProcessPointsList()[0].PROCESS_POINT() + "</label><span class='scount'>" + SurveyTrackingVM.SurveyProcessPointsList()[0].COUNT() + "</span>" +
                    "</div>" +
                    "</div>" +
                    " </div>" +
                    "</div> </div>";

                document.getElementById('divDashboard').innerHTML = DynamicHtml;
                ko.applyBindingsToNode($('#TotalST'), { click: SurveyTrackingVM.ClearAllBuFilters }, SurveyTrackingVM);

                for (var i = 1; i < SurveyTrackingVM.SurveyProcessPointsList().length; i++) {
                    ko.applyBindingsToNode($('#headcoltest_' + i), { click: SurveyTrackingVM.FiltersForGraphs }, SurveyTrackingVM.SurveyProcessPointsList()[i].PROCESS_ID());
                }
                applySrollableComponent();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:BindPieChartForProcessPoints() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function applySrollableComponent() {
            var itemsMainDiv = ('.MultiCarousel');
            var itemsDiv = ('.MultiCarousel-inner');
            var itemWidth = "";

            $('.leftLst, .rightLst').click(function () {
                var condition = $(this).hasClass("leftLst");
                if (condition)
                    click(0, this);
                else
                    click(1, this)
            });

            ResCarouselSize();

            $(window).resize(function () {
                ResCarouselSize();
            });

            //this function define the size of the items
            function ResCarouselSize() {
                var incno = 0;
                var dataItems = ("data-items");
                var itemClass = ('.item');
                var id = 0;
                var btnParentSb = '';
                var itemsSplit = '';
                var sampwidth = $(itemsMainDiv).width();
                var bodyWidth = $('body').width();
                $(itemsDiv).each(function () {
                    id = id + 1;
                    var itemNumbers = $(this).find(itemClass).length;
                    btnParentSb = $(this).parent().attr(dataItems);
                    itemsSplit = btnParentSb.split(',');
                    $(this).parent().attr("id", "MultiCarousel" + id);


                    if (bodyWidth >= 900) {
                        incno = itemsSplit[1];
                        itemWidth = sampwidth / incno;
                    }
                    else if (bodyWidth >= 900) {
                        incno = itemsSplit[1];
                        itemWidth = sampwidth / incno;
                    }

                    $(this).css({ 'transform': 'translateX(0px)', 'width': itemWidth * itemNumbers });
                    $(this).find(itemClass).each(function () {
                        $(this).outerWidth(itemWidth);
                    });

                    $(".leftLst").addClass("over");
                    $(".rightLst").removeClass("over");

                });
            }

            //this function used to move the items
            function ResCarousel(e, el, s) {
                var leftBtn = ('.leftLst');
                var rightBtn = ('.rightLst');
                var translateXval = '';
                var divStyle = $(el + ' ' + itemsDiv).css('transform');
                var values = divStyle.match(/-?[\d\.]+/g);
                var xds = Math.abs(values[4]);
                if (e == 0) {
                    translateXval = parseInt(xds) - parseInt(itemWidth * s);
                    $(el + ' ' + rightBtn).removeClass("over");

                    if (translateXval <= itemWidth / 2) {
                        translateXval = 0;
                        $(el + ' ' + leftBtn).addClass("over");
                    }
                }
                else if (e == 1) {
                    var itemsCondition = $(el).find(itemsDiv).width() - $(el).width();
                    translateXval = parseInt(xds) + parseInt(itemWidth * s);
                    $(el + ' ' + leftBtn).removeClass("over");

                    if (translateXval >= itemsCondition - itemWidth / 2) {
                        translateXval = itemsCondition;
                        $(el + ' ' + rightBtn).addClass("over");
                    }
                }
                $(el + ' ' + itemsDiv).css('transform', 'translateX(' + -translateXval + 'px)');
            }

            //It is used to get some elements from btn
            function click(ell, ee) {
                var Parent = "#" + $(ee).parent().attr("id");
                var slide = $(Parent).attr("data-slide");
                ResCarousel(ell, Parent, slide);
            }
        }

        //#endregion

        //#region Email Methods

        function SendSurveyReminderNotification(data, event) {
            try {
                app.showMessage((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('SendSurveyReminder') == -1) ? 'Do you want to send an e-mail reminder notification to this Survey Owner/Reviewer?' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('SendSurveyReminder')].Name, (!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('sendEmailReminderHeader') == -1) ? 'Send e-mail reminder notification' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('sendEmailReminderHeader')].Name, [(!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('SendButton') == -1) ? 'Send' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('SendButton')].Name, (!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name], false, { primaryButtonClass: "fa-check fa-dialog btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-secondary", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-envelope text-default' })
                    .then(function (option) {
                        var confirmText = ((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('SendButton') == -1) ? 'Send' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('SendButton')].Name()).toString();
                        if (option == confirmText) {
                            GetUserEmailDetails(data);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception' + e + ' || Source: SendSurveyReminderNotification() in SurveyTracking.js';
                logger.logMessage(msg)
            }
        }

        function GetUserEmailDetails(data) {
            try {
                $.ajax({
                    url: "/api/Survey/GetUserEmailDetails?SurveyId=" + data.SurveyId() + "&SurveyType=" + data.PPDISPNAME(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                }).success(function (result) {
                    if (result != null) {
                        if (result != null && result.substring(0, 3) == "INC") {
                            logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1)
                                ? result + " - An error occurred. Please contact your Application Administrator."
                                : result + " - " + SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                        }
                        else {
                            data.Email = ko.observable(result);
                            SendEmailtoValidRecepients(data);
                        }
                    }

                }).fail(function () {
                });

            } catch (e) {
                var msg = 'Exception' + e + ' || Source:  GetUserEmailDetails() in SurveyTracking.js';
                logger.logMessage(msg)
            }
        }

        function SendEmailtoValidRecepients(data, template) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/SendEmailtoValidRecepients",
                    type: "POST",
                    headers: headers,
                    data: data
                })
                    .success(function (Jsonresult, error) {
                        logger.logSuccess((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('emailsuccessmsg') == -1) ? 'E-mail reminder notification sent out successfully.' : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('emailsuccessmsg')].Name(), 'Success', system.getModuleId(SurveyTrackingVM), true);
                    })
                    .fail(function (error, fail) {
                        logger.logError((!SurveyTrackingVM.LocaleCheckFlag() || SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? "An error occurred. Please contact your Application Administrator." : SurveyTrackingVM.ObjGeneralSettings.LocalizedTextList()[SurveyTrackingVM.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(SurveyTrackingVM), true);
                    })
            }
            catch (e) {
                var msg = 'Exception' + e + ' || Source: SendEmailtoValidRecepients() in SurveyTracking.js';
                logger.logMessage(msg)
            }
        }

        //#endregion

        //#region Click Events

        function NavTabClick(data, event) {
            try {
                if (typeof (event) == "undefined") { // First Load Condition
                    SurveyTrackingVM.NavPillId("SUR");
                    $(".nav-pills a").first().addClass("active");
                }
                else {
                    SurveyTrackingVM.NavPillId(event.currentTarget.id); // Get the Id of Navbar Pill Selected
                    $('.nav-pills a').removeClass("active");
                    SurveyTrackingVM.ObjGeneralSettings.NavPillIdSurveyTracking(event.currentTarget.id);
                    document.getElementById(SurveyTrackingVM.NavPillId()).classList.add("active");
                }
                ClearAllBuFilters();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavTabClick() in SurveyTracking.js';
                logger.logMessage(msg);

            }
        }

        function SurveyClick(data) {
            try {
                SurveyTrackingVM.SurveyType(data.SurveyType());
                SurveyTrackingVM.RoutedFrom("Tracking");
                SurveyTrackingVM.SurveyTypeDisplayName(data.PPDISPNAME());
                if (data.PPDISPNAME() === 'SUR')
                    NavigateSurveyResponse(data);
                if (data.PPDISPNAME() === 'SOC')
                    NavigateSocializationResponse(data)
                if (data.PPDISPNAME() === 'PCS')
                    NavigatePCSResponse(data)
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | SurveyClick() in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function showSurveyInfoClick(SurveyId) {
            try {
                if ($('#surveyInfoDiv_' + SurveyId).is(':visible')) {
                    $('#surveyInfoDiv_' + SurveyId).hide();
                    $('#surveyInfoDivMore_' + SurveyId).show();
                    $('#surveyInfoDivLess_' + SurveyId).hide();
                }
                else {
                    $('#surveyInfoDiv_' + SurveyId).show();
                    $('#surveyInfoDivLess_' + SurveyId).show();
                    $('#surveyInfoDivMore_' + SurveyId).hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showSurveyInfoClick() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function showWFDescription(data, event) {
            try {
                if ($('#WFDescDiv').is(':visible')) {
                    $('#WFDescDiv').hide();
                    $('#showWFDescBtn').show();
                    $('#hideWFDescBtn').hide();
                    $('#showWFDescBtn').addClass('nd-flex');
                    $('#hideWFDescBtn').removeClass('nd-flex');
                }
                else {
                    $('#WFDescDiv').show();
                    $('#hideWFDescBtn').show();
                    $('#showWFDescBtn').hide();
                    $('#hideWFDescBtn').addClass('nd-flex');
                    $('#showWFDescBtn').removeClass('nd-flex');
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showWFDescription() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function showTimelineComments(data, event) {
            try {
                if ($('#showCmpltTimelineBtn').is(':visible')) {
                    SurveyTrackingVM.TimelineCommentsFlag(true);
                    $('#showCmpltTimelineBtn').hide();
                    $('#showLessTimelineBtn').show();
                }
                else {
                    SurveyTrackingVM.TimelineCommentsFlag(false);
                    $('#showCmpltTimelineBtn').show();
                    $('#showLessTimelineBtn').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showTimelineComments() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function ViewStatus() {
            try {
                SurveyTrackingVM.CheckBoxCount(0);
                $('#loadingImg').show();
                if (SurveyTrackingVM.OrgLvlDrpDwnList().length > 0) {
                    if (SurveyTrackingVM.ViewChart() == 0) {
                        var count = 0
                        if (SurveyTrackingVM.OrgLvlDrpDwnList().length > 2) {

                            for (var i = 0; i < SurveyTrackingVM.OrgLvlDrpDwnList().length; i++) {

                                $($('#' + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BlId())).prop("checked", true);
                                count = i;
                            }
                        }
                        else if (SurveyTrackingVM.OrgLvlDrpDwnList().length == 2) {
                            $($('#' + SurveyTrackingVM.OrgLvlDrpDwnList()[0].BlId())).prop("checked", true);
                            $($('#' + SurveyTrackingVM.OrgLvlDrpDwnList()[1].BlId())).prop("checked", true);
                            count = 1;
                        }
                        else if (SurveyTrackingVM.OrgLvlDrpDwnList().length == 1) {
                            $($('#' + SurveyTrackingVM.OrgLvlDrpDwnList()[0].BlId())).prop("checked", true);
                            count = 0
                        }


                        for (var i = 0; i <= count; i++) {
                            for (var j = 0; j < SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                                $("#sublevel" + SurveyTrackingVM.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId()).prop("checked", true);
                            }
                        }
                        SurveyTrackingVM.ViewChart(SurveyTrackingVM.ViewChart() + 1)
                    }
                }
                else {
                    $('#loadingImg').hide();
                    $('#error').show();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ViewStatus() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Navigation Methods

        function RouteToResponseScreen(data, event) {
            try {
                var SurveyProfileId = data.SurveyId();
                var SurveyTypeId = data.SurveyCode();
                var PageHeaderName = data.SurveyType();
                var BusinessUnitId = data.BuId();
                var BusinessUnitName = data.BuName();
                var SurveyId = data.SurveyNumber();
                var RoleId = SurveyTrackingVM.appsecurity.userInfo().PrimaryRoleId();
                var RoleName = SurveyTrackingVM.appsecurity.userInfo().PrimaryRoleName();
                var Status = (data.finalizeSurvey() == "NO") ? "InProgress" : "Completed";
                var hasSurveyNC = data.HAS_SURVEY_NARRATIVE_COMMENTS();
                var hasAreaNC = data.HAS_AREA_NARRATIVE_COMMENTS();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RouteToResponseScreen() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function NavigateSurveyResponse(data) {
            try {
                var SurveyId = data.SurveyId(),
                    SurveyName = data.SurveyName(),
                    SurveyProfileId = data.SP_UID(),
                    BuId = data.BuId(),
                    BUName = data.BuName(),
                    Status = data.status(),
                    PendingAt = data.PendingAt(),
                    SurveyType = data.PPDISPNAME(),
                    SurveyTypeName = data.SurveyType(),
                    CompletionPercentage = data.Percentage(),
                    DueDate = data.DueDate(),
                    BUList = data.BuList(),
                    BUListString = data.BUListString(),
                    GroupShortName = data.SurveyCode(), //QLDR, QTDT, CDR
                    SurveyIconClass = data.ICON_CLASS(),
                    SurveyStateName = data.SurveyStateName(),
                    GroupId = data.GroupId(), //146
                    UserList = data.AssignedUser(),
                    ProfileName = data.ProfileName(),
                    ComponentName = data.ComponentName()

                var IsPendingFlag = 0, IsCompletedFlag = 0;
                if (data.CompletedFlag == true) {
                    IsPendingFlag = 0;
                    IsCompletedFlag = 1;
                }
                else {
                    IsPendingFlag = 1;
                    IsCompletedFlag = 0;
                }

                if (SurveyTrackingVM.appsecurity != undefined && SurveyTrackingVM.appsecurity.userInfo() != undefined && SurveyTrackingVM.appsecurity.userInfo().PrimaryRoleId() != undefined) {
                    SurveyTrackingVM.RoleValue(SurveyTrackingVM.appsecurity.userInfo().PrimaryRoleId());
                    SelectedRoleName = SurveyTrackingVM.appsecurity.userInfo().PrimaryRoleName();
                    SurveyTrackingVM.RoleId(SurveyTrackingVM.RoleValue());
                }

                SurveyTrackingVM.ResponseMoveArray(new ResponseMoveModel({
                    SurveyId: SurveyId,
                    SurveyName: SurveyName,
                    SurveyProfileId: SurveyProfileId,
                    PendingAt: PendingAt,
                    BusinessUnitId: BuId,
                    BusinessUnitName: BUName,
                    SurveyType: SurveyType,
                    RoleId: SurveyTrackingVM.RoleValue(),
                    RoleName: SelectedRoleName,
                    SurveyIconClass: SurveyIconClass,
                    CompletionPercentage: CompletionPercentage,
                    DueDate: DueDate,
                    BUList: BUList,
                    BUListString: BUListString,
                    SurveyStatus: Status,
                    GroupShortName: GroupShortName,
                    SurveyTypeName: SurveyTypeName,
                    GroupId: GroupId,
                    UserList: UserList,
                    IsPendingFlag: IsPendingFlag,
                    IsCompletedFlag: IsCompletedFlag,
                    RoleId: SurveyTrackingVM.RoleValue(),
                    RoleName: SelectedRoleName,
                    SurveyStateName: SurveyStateName,
                    ProfileName: ProfileName,
                    ComponentName: ComponentName
                }));

                router.navigate("#survey/SurveyResponsePage", true);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | NavigateSurveyResponse() in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function NavigateSocializationResponse(data) {
            try {
                appsecurity.SocializationReadOnly(false);
                SurveyTrackingVM.ResponseMoveArray([]);
                var socType = 'Normal';

                if (data.BuName() === 'Overall Socialization')
                    socType = 'Overall';

                SurveyTrackingVM.ResponseMoveArray(new ResponseMoveModel({
                    BusinessUnitId: data.BuId(),
                    BusinessUnitName: data.BuName(),
                    CurrentProfileOfAssessmentId: SurveyTrackingVM.CurrentProfileOfAssessmentId(),
                    SurveyName: data.SurveyName(),
                    SurveyId: data.SurveyId(),
                    SurveyIconClass: data.ICON_CLASS(),
                    DueDate: data.DueDate(),
                    SurveyStatus: data.status(),
                    PendingAt: data.PendingAt(),
                    AssessmentTypeId: data.SP_UID(), // Passing RAT_UID (SP_UID is placeholder for RAT for socio data)
                    GroupId: parseInt(data.GroupId()),// 2 = CRA and 1 = AML / OFAC
                    UserList: data.AssignedUser(),
                    SocType: socType,
                    IsCompletedFlag: (data.CompletedFlag) ? 1 : 0,
                    IsPendingFlag: (data.CompletedFlag) ? 0 : 1,
                    SurveyStateName: data.SurveyStateName(),
                    ProfileName: data.ProfileName(),
                    ComponentName: data.ComponentName(),
                    BUList: data.BuList(),
                    SurveyType: data.PPDISPNAME()
                }));
                router.navigate("#RaSocialization/SocializationResponse", true);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | NavigateSocializationResponse() in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function NavigatePCSResponse(data) {
            try {
                SurveyTrackingVM.ResponseMoveArray([]);
                SurveyTrackingVM.ResponseMoveArray(new ResponseMoveModel({

                    CurrentProfileOfAssessmentId: SurveyTrackingVM.CurrentProfileOfAssessmentId(),
                    SurveyName: data.SurveyName(),
                    SurveyId: data.SurveyId(),
                    SurveyIconClass: data.ICON_CLASS(),
                    DueDate: data.DueDate(),
                    SurveyStatus: data.status(),
                    PendingAt: data.PendingAt(),
                    SurveyProfileId: data.SP_UID(),
                    UserList: data.AssignedUser(),
                    IsCompletedFlag: (data.CompletedFlag) ? 1 : 0,
                    IsPendingFlag: (data.CompletedFlag) ? 0 : 1,
                    SurveyStateName: data.SurveyStateName(),
                    ProfileName: data.ProfileName(),
                    ComponentName: data.ComponentName()
                }));
                router.navigate("#RiskRating/RiskRatingResponsePage", true);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | NavigatePCSResponse() in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Models

        function ResponseMoveModel(item) {
            try {
                var self = this;
                if (SurveyTrackingVM.SurveyTypeDisplayName() === 'SUR') {
                    self.SurveyId = ko.observable(item.SurveyId);
                    self.SurveyName = ko.observable(item.SurveyName);
                    self.SurveyProfileId = ko.observable(item.SurveyProfileId);
                    self.GroupName = ko.observable(item.GroupName);
                    self.GroupShortName = ko.observable(item.GroupShortName);
                    self.BusinessUnitId = ko.observable(item.BusinessUnitId);
                    self.BusinessUnitName = ko.observable(item.BusinessUnitName);
                    self.BusinessUnitDescription = ko.observable(item.BusinessUnitDescription); // not passing
                    self.BusinessType = ko.observable(item.BusinessType); // not passing
                    self.SurveyType = ko.observable(item.SurveyType); // to differentiate surveys like RA survey(SUR), socialization survey(SOC)
                    self.RoleId = ko.observable(item.RoleId);
                    self.RoleName = ko.observable(item.RoleName);
                    self.SurveyTypeId = ko.observable(item.SurveyTypeId);
                    self.CompletionPercentage = ko.observable(item.CompletionPercentage);
                    self.DueDate = ko.observable(item.DueDate);
                    self.BUList = ko.observable(item.BUList);
                    self.BUListString = ko.observable(item.BUListString);
                    self.SurveyStatus = ko.observable(item.SurveyStatus);
                    self.PendingAt = ko.observable(item.PendingAt);
                    self.SurveyIconClass = ko.observable(item.SurveyIconClass);
                    self.UserList = ko.observable(item.UserList);
                    self.IsCompletedFlag = ko.observable(item.IsCompletedFlag);
                    self.IsPendingFlag = ko.observable(item.IsPendingFlag);
                    self.GroupId = ko.observable(item.GroupId);
                    self.SurveyStateName = ko.observable(item.SurveyStateName);
                    self.ComponentName = ko.observable(item.ComponentName);
                    self.ProfileName = ko.observable(item.ProfileName);
                }
                else if (SurveyTrackingVM.SurveyTypeDisplayName() === 'SOC') {

                    self.BusinessUnitId = ko.observable(item.BusinessUnitId);
                    self.BusinessUnitName = ko.observable(item.BusinessUnitName);
                    self.SurveyName = ko.observable(item.SurveyName);
                    self.SurveyId = ko.observable(item.SurveyId);
                    self.SurveyIconClass = ko.observable(item.SurveyIconClass);
                    self.DueDate = ko.observable(item.DueDate);
                    self.SurveyStatus = ko.observable(item.SurveyStatus);
                    self.PendingAt = ko.observable(item.PendingAt);
                    self.CurrentProfileOfAssessmentId = ko.observable(item.CurrentProfileOfAssessmentId);
                    self.GroupId = ko.observable(item.GroupId);
                    self.UserList = ko.observable(item.UserList);
                    self.SocType = ko.observable(item.SocType);
                    self.IsCompletedFlag = ko.observable(item.IsCompletedFlag);
                    self.IsPendingFlag = ko.observable(item.IsPendingFlag);
                    self.SurveyStateName = ko.observable(item.SurveyStateName);
                    self.ComponentName = ko.observable(item.ComponentName);
                    self.ProfileName = ko.observable(item.ProfileName);
                    self.BUList = ko.observable(item.BUList);
                    self.SurveyType = ko.observable(item.SurveyType);
                    self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
                }
                else if (SurveyTrackingVM.SurveyTypeDisplayName() === 'PCS') {
                    self.SurveyId = ko.observable(item.SurveyId);
                    self.SurveyName = ko.observable(item.SurveyName);
                    self.SurveyProfileId = ko.observable(item.SurveyProfileId);
                    self.BusinessUnitId = ko.observable(item.BusinessUnitId);
                    self.BusinessUnitName = ko.observable(item.BusinessUnitName);
                    self.BusinessUnitDescription = ko.observable(item.BusinessUnitDescription); // not passing
                    self.BusinessType = ko.observable(item.BusinessType); // not passing
                    self.SurveyType = ko.observable(item.SurveyType); // to differentiate surveys like RA survey(SUR), socialization survey(SOC)
                    self.RoleId = ko.observable(item.RoleId);
                    self.RoleName = ko.observable(item.RoleName);
                    self.SurveyTypeId = ko.observable(item.SurveyTypeId);
                    self.CompletionPercentage = ko.observable(item.CompletionPercentage);
                    self.DueDate = ko.observable(item.DueDate);
                    self.BUList = ko.observable(item.BUList);
                    self.SurveyStatus = ko.observable(item.SurveyStatus);
                    self.PendingAt = ko.observable(item.PendingAt);
                    self.SurveyIconClass = ko.observable(item.SurveyIconClass);
                    self.UserList = ko.observable(item.UserList);
                    self.IsCompletedFlag = ko.observable(item.IsCompletedFlag);
                    self.IsPendingFlag = ko.observable(item.IsPendingFlag);
                    self.CurrentProfileOfAssessmentId = ko.observable(item.CurrentProfileOfAssessmentId);
                    self.SurveyStateName = ko.observable(item.SurveyStateName);
                    self.ComponentName = ko.observable(item.ComponentName);
                    self.ProfileName = ko.observable(item.ProfileName);
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: ResponseMoveModel() in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function BusinessUnitModel(item) {
            try {
                var self = this;
                self.BU_ID = ko.observable(item.BU_ID);
                self.BU_NAME = ko.observable($('<div/>').html(item.BU_NAME).text());
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BuId).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
                var value = item.BU_NAME
                var buVal = "";
                if (item.BU_NAME === undefined) {
                    buVal = item.BuName;
                } else {
                    buVal = item.BU_NAME;
                }
                if (buVal != undefined && buVal.length > 50) {
                    value = buVal.substring(0, 50) + '...';
                } else {
                    var space = buVal.length;
                    var spaceText = '';
                    for (j = 0; j < 5 - space; j++) {
                        spaceText += '&nbsp';
                    }
                    value = spaceText + buVal + spaceText;
                }

                self.BuName = ko.observable($('<div/>').html(value).text());
                self.AssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
                self.SubLevelId = ko.observable(item.SubLevelId);
                self.isChecked = ko.observable(false);
                self.BU_ID = ko.observable(item.BU_ID);
            }
            catch (e) {
                var msg = 'exception' + e + 'source: BusinessUnitModel() in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function BusinessUnitModelDUP(item) {
            try {
                var self = this;
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BU_ID = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BuId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.BuName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.BU_NAME = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.AssessmentDate = ko.observable($('<div/>').html(item.AssessmentDate()).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus()).text());
                self.SubLevelId = ko.observable(item.SubLevelId());
                self.isChecked = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitModelDUP() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function PushBackModel(item) {
            try {
                var self = this;
                self.EVENT_ID = ko.observable($('<div/>').html(item.EVENT_ID).text());
                self.EVENT_NAME = ko.observable($('<div/>').html(item.EVENT_NAME).text());
                self.COMMENT_TEXT = ko.observable($('<div/>').html(item.COMMENT_TEXT).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PushBackModel() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function ProcessPointsModel(item) {
            try {
                var self = this;
                self.PROCESS_ID = ko.observable($('<div/>').html(item.PROCESS_ID).text());
                self.PROCESS_POINT = ko.observable($('<div/>').html(item.PPDISPNAME).text());
                self.PROCESS_POINT_NAME = ko.observable($('<div/>').html(item.PPDISPNAME).text());
                self.COLORCODE = ko.observable($('<div/>').html(item.COLORCODE).text());
                self.ProcessPointId = ko.observable($('<div/>').html(item.PROCESS_POINT_ID).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ProcessPointsModel() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function SurveyProcessModel(item) {
            try {
                var self = this;
                self.PROCESS_ID = ko.observable($('<div/>').html(item.PROCESS_ID).text());
                self.PROCESS_POINT = ko.observable($('<div/>').html(item.PROCESS_POINT).text());
                self.COUNT = ko.observable($('<div/>').html(item.COUNT).text());
                self.COLORCODE = ko.observable($('<div/>').html(item.COLORCODE).text());
                self.SurveyStatus = ko.observable(item.SurveyStatus);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyProcessModel() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function SurveyLegendModel(item) {
            try {
                var self = this;
                self.StateId = ko.observable($('<div/>').html(item.StateId).text());
                self.StateName = ko.observable($('<div/>').html(item.StateName).text());
                self.StateShortName = ko.observable($('<div/>').html(item.StateShortName).text());
                self.StateColor = ko.observable($('<div/>').html(item.StateColor).text());
                self.StateColorClass = ko.observable($('<div/>').html(item.StateColorClass).text());
                self.StateIconClass = ko.observable($('<div/>').html(item.StateIconClass).text());
                self.SortOrder = ko.observable($('<div/>').html(item.SortOrder).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyLegendModel() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function SurveyProfileModel(item) {
            try {
                var self = this;
                self.SurveyProfileId = ko.observable($('<div/>').html(item.SurveyProfileId).text());
                self.SurveyProfileName = ko.observable($('<div/>').html(item.SurveyProfileName).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyProfileModel() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function BusinessLevelsModel(item) {
            try {
                var self = this;
                self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
                self.BlName = ko.observable($('<div/>').html(item.BlName).text());
                self.BlId = ko.observable(item.BlId)
                var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                    return new BuLevelValueListModel(result);
                });
                self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessLevelsModel() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function BuLevelValueListModel(item) {
            try {
                var self = this;
                self.BlvalueId = ko.observable(item.BlvalueId);
                self.BlvalueName = ko.observable($('<div/>').html(item.BlvalueName).text());
                self.ParentBuLevel = ko.observable($('<div/>').html(item.ParentBuLevel).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        function SurveytrackingModel(item) {
            try {
                var self = this;
                self.SP_UID = ko.observable(item.SP_UID);
                self.SurveyNumber = ko.observable(item.SurveyNumber);
                self.SurveyName = ko.observable(item.SurveyName);
                self.aging = ko.observable($('<div/>').html(item.aging).text());

                if (self.aging() == '1')
                    self.aging(self.aging() + " day");
                else {
                    self.aging(self.aging() + " days");
                }

                self.SurveyId = ko.observable($('<div/>').html(item.SurveyId).text());
                self.BuName = ko.observable($('<div/>').html(item.BuName).text());
                self.ColorCode = ko.observable($('<div/>').html(item.COLOR_CODE).text());
                self.SurveyCode = ko.observable($('<div/>').html(item.SurveyCode).text());
                self.BuId = ko.observable(item.BuId);
                self.PendingAt = ko.observable($('<div/ > ').html(item.PendingAt).text());
                self.PPDISPNAME = ko.observable($('<div/>').html(item.PPDISPNAME).text());
                self.status = ko.observable($('<div/>').html(item.status).text());
                self.AssignedUser = ko.observable($('<div/>').html(item.AssignedUser).text());

                if (item.AssignedUser == "" || item.AssignedUser == " " || item.AssignedUser == undefined) {
                    self.AssignedUser = ko.observable("No user assigned");
                }

                self.DueDate = ko.observable($('<div/>').html(item.DueDate).text());
                self.Percentage = ko.observable($('<div/>').html(item.Percentage).text());
                self.ICON_CLASS = ko.observable($('<div/>').html(item.ICON_CLASS).text());
                self.GroupId = ko.observable($('<div/>').html(item.GroupId).text());
                self.SurveyStateName = ko.observable($('<div/>').html(item.SurveyStateName).text());
                self.ComponentName = ko.observable($('<div/>').text(item.ComponentName).text());
                self.CompletedFlag = item.CompletedFlag;

                // logic to add html part and modifications to RG Name and BUList attributes on Survey Card
                var rgName = item.ProfileName;
                var rgString = "<span class='bu-lbl'><strong class='lbl-space-rg'>" + SurveyTrackingVM.RGName() + ":</strong><span class='bu-val' title='" + rgName + "'>" + rgName + "</span></span>";;

                self.SurveyType = ko.observable(rgName);
                self.ProfileName = ko.observable(rgString);

                var BUList = item.BuList;
                var BUlistStringHTML = "";
                var BUlistString = BUList.substring(0, BUList.length - 1);

                if (BUList != null || BUList != "") {
                    var BUListSplit = BUList.toString().split("`");
                    for (var n = 0; n < BUListSplit.length - 1; n++) {
                        var BUListSplitInner = BUListSplit[n].toString().split(":");
                        BUlistStringHTML += "<span class='bu-lbl'><strong class='lbl-space'>" + BUListSplitInner[0] + ":</strong><span class='bu-val' title='" + BUListSplitInner[1] + "'>" + BUListSplitInner[1] + "</span></span>";
                    }
                }
                self.BuList = ko.observable(BUlistStringHTML);
                self.BUListString = ko.observable(BUlistString);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveytrackingModel() method in SurveyTracking.js';
                logger.logMessage(msg);
            }
        }

        //#endregion
    });
